<template>
  <div style="width: 100%" v-if="detailPage == 1">
    <div
      id="title-danhsach"
      class="row-header"
      style="
        height: 38px;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
      "
    >
      <div class="background-triangle-big view_tp_pdf">
        <span>Tra cứu thông tin {{ module["pathParent"] }}</span>
      </div>
      <div class="collapsible1 mr-3" style="cursor: pointer">
        <span
          @click="isToggle = !isToggle"
          style="font-weight: bold; color: blue"
          >Tìm kiếm <i class="mdi mdi-chevron-down" v-if="!isToggle"></i
          ><i class="mdi mdi-chevron-up" v-if="isToggle"></i
        ></span>
      </div>
    </div>
    <div
      class="collapsible-content pb-1"
      v-if="isToggle"
      style="background: #fff"
    >
      <v-layout wrap class="ml-0">
        <v-flex
          xs12
          sm3
          class=""
          style="
            margin-top: 4px;
            font-size: 13px;
            text-align: right;
            padding-right: 10px;
          "
        >
          <span class="text-xs-right">Hình thức tra cứu: </span>
        </v-flex>
        <v-flex xs12 sm9
          style="
            margin-top: 4px;
            font-size: 13px;
            padding-right: 10px;
          ">
          <input type="radio" id="tt" value="tt" style="margin-left: 10px;" v-model="chooseTypeTraCuu" @click="clickTypeTraCuu()">
          <label for="tt"><b>Kết quả thủ tục hành chính</b></label>

          <input type="radio" id="dt" value="dt" style="margin-left: 10px;" v-model="chooseTypeTraCuu" @click="clickTypeTraCuu()">
          <label for="dt"><b>Phương tiện SXLR</b></label>
        </v-flex>
        <v-flex v-if="chooseTypeTraCuu == 'tt'"
          xs12
          sm3
          class=""
          style="
            margin-top: 4px;
            font-size: 13px;
            text-align: right;
            padding-right: 10px;
          "
        >
          <span class="text-xs-right">Chọn Thủ tục hành chính: </span>
        </v-flex>
        <v-flex xs12 sm9 class="pr-1" v-if="chooseTypeTraCuu == 'tt'">
          <v-autocomplete
            @input="selectModuleAction()"
            v-model="selectModule"
            :items="modules"
            return-object
            item-text="name"
            item-value="module"
            autocomplete
            placeholder="Tên Module"
          >
          </v-autocomplete>
        </v-flex>
        <v-flex v-if="chooseTypeTraCuu == 'dt'"
          xs12
          sm3
          class=""
          style="
            margin-top: 4px;
            font-size: 13px;
            text-align: right;
            padding-right: 10px;
          "
        >
          <span class="text-xs-right">Chọn đối tượng: </span>
        </v-flex>
        <v-flex xs12 sm9 class="pr-1" v-if="chooseTypeTraCuu == 'dt'">
          <v-autocomplete
            @input="selectObjectPTAction()"
            v-model="selectObjectPT"
            :items="objectPT"
            return-object
            item-text="name"
            item-value="module"
            autocomplete
            placeholder="Tên đối tượng"
          >
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm3 md3 v-if="chooseTypeTraCuu != 0">
          <div>
            <!-- <v-chip
                            style="height: 22px; color: #fff;"
                            color="primary"
                            label
                            @click="addSearch"
                            >
                            <v-icon size="17" style="color: #fff; font-size: 16px">add</v-icon> Thêm
                        </v-chip> -->

            <span
              style="
                float: right;
                padding-right: 10px;
                font-size: 13px;
                margin-top: 7px;
              "
              >Điều kiện tìm kiếm:
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm9 md9 class="mt-1">
          <div
            class="filter-item"
            v-for="(item, index) in listSearch"
            :key="index"
            style="clear: both; display: flex"
          >
            <v-autocomplete v-if="chooseTypeTraCuu != 0"
              style="display: inline-block; width: 36%; float: left"
              outlined
              autocomplete
              class="pr-2 pt-0"
              @input="changeCondition(item)"
              :items="conditions"
              item-text="value"
              clearable
              v-model="item['conditionsSelect']"
              return-object
            ></v-autocomplete>
            <v-text-field
              style="display: inline-block; width: 35%"
              v-if="
                item['conditionsSelect'] &&
                (item['conditionsSelect']['type'] === 'string' ||
                  item['conditionsSelect']['type'] === 'keyword')
              "
              outlined
              class="pr-1 pt-0"
              placeholder="Nhập từ khóa"
              v-model="item['valueSearch']"
            >
            </v-text-field>
            <v-text-field
              style="display: inline-block; width: 35%"
              v-if="
                item['conditionsSelect'] &&
                item['conditionsSelect']['type'] === 'number'
              "
              outlined
              class="pt-0"
              type="number"
              placeholder="Nhập số"
              v-model="item['valueSearch']"
            >
            </v-text-field>

            <v-menu
              ref="menuDateTraCuuFrom"
              :close-on-content-click="false"
              v-if="
                item['conditionsSelect'] &&
                item['conditionsSelect']['type'] === 'date'
              "
              v-model="menuDateTraCuuFrom"
              :nudge-right="40"
              :return-value.sync="date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              style="width: 30%; display: normal"
            >
              <v-text-field
                slot="activator"
                v-model="item['fromDate']"
                append-icon="event"
                clearable
                class="pt-0 pr-1"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="item['fromDateTraCuu']"
                @input="parseDateTraCuuFrom(item)"
              ></v-date-picker>
            </v-menu>
            <!-- <DateTimePicker
                            style="display: inline-block; width: 25%;"
                            v-if="item['conditionsSelect']['type'] === 'date'"
                            v-model="item['fromDate']"
                            :first-day="1"
                            class="py-0 my-0"
                            :show-dst="false"
                            :show-hours="true"
                            :show-minutes="true"
                            :show-seconds="false"
                        ></DateTimePicker> -->

            <v-menu
              ref="menuDateTraCuuTo"
              :close-on-content-click="false"
              v-if="
                item['conditionsSelect'] &&
                item['conditionsSelect']['type'] === 'date'
              "
              v-model="menuDateTraCuuTo"
              :nudge-right="40"
              :return-value.sync="date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              style="width: 28%; display: normal"
            >
              <v-text-field
                slot="activator"
                v-model="item['toDate']"
                append-icon="event"
                clearable
                class="pt-0"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="item['toDateTraCuu']"
                @input="parseDateTraCuuTo(item)"
              ></v-date-picker>
            </v-menu>

            <!-- <DateTimePicker
                            style="display: inline-block; width: 25%;"
                            v-if="item['conditionsSelect']['type'] === 'date'"
                            v-model="item['toDate']"
                            :first-day="1"
                            class="py-0 my-0"
                            :show-dst="false"
                            :show-hours="true"
                            :show-minutes="true"
                            :show-seconds="false"
                        ></DateTimePicker> -->

            <!-- :items="
                (item['conditionsSelect']['items'] && item['conditionsSelect']['items']['length']) || getSelect(item['key'])
              " -->
            <v-autocomplete
              style="display: inline-block; width: 30%"
              v-if="
                item['conditionsSelect'] &&
                item['conditionsSelect']['type'] === 'select'
              "
              v-model="item['valueSearch']"
              :items="item['conditionsSelect']['items']"
              outlined
              autocomplete
              class="pt-0"
              item-text="itemText"
              item-value="itemValue"
            >
            </v-autocomplete>

            <!-- <v-autocomplete
              v-if="
                item['conditionsSelect'] &&
                (item['conditionsSelect']['type'] === 'string' ||
                  item['conditionsSelect']['type'] === 'number' ||
                  item['conditionsSelect']['type'] === 'keyword')
              "
              v-model="item['typeSearch']"
              :items="item['typeSearchItems']"
              item-text="name"
              class="pt-0"
              item-value="altername"
              autocomplete
              style="display: inline-block; width: 20%"
              outlined
            ></v-autocomplete> -->

            <v-chip v-if="chooseTypeTraCuu != 0"
              class="mt-2"
              style="height: 22px; float: right; cursor: pointer"
              label
              @click="removeSearch(item, index)"
            >
              <v-icon
                size="18"
                style="font-size: 17px; cursor: pointer"
                color="red"
                >delete_outline</v-icon
              >
            </v-chip>
            <br />
          </div>
        </v-flex>
        <v-flex xs12 sm7 class="text-xs-right">
          <!-- <v-chip
                    style="height: 22px; color: #fff;"
                    color="primary"
                    label
                    @click="addSearch"
                    >
                    <v-icon size="17" style="color: #fff; font-size: 16px">add</v-icon> Thêm
                  </v-chip>

                  <span style="float: right; padding-right: 10px; font-size: 13px; margin-top: 6px;">Điều kiện tìm kiếm: </span> -->
          <v-btn
            small
            color="primary"
            class="ml-0"
            @click="addSearch()"
            style=""
            ><v-icon size="17" style="color: #fff; font-size: 17px">add</v-icon>
            Thêm điều kiện</v-btn
          >
          <v-btn
            small
            color="primary"
            class="ml-0"
            @click="traCuuThongKe()"
            style=""
            ><v-icon size="17" style="color: #fff; font-size: 17px"
              >search</v-icon
            >
            Tìm kiếm</v-btn
          >
        </v-flex>

        <v-flex
          xs12
          sm5
          class="text-xs-right"
          style="display: flex; align-items: center; justify-content: flex-end"
        >
          <span style="padding-top: 5px">
            <i>Tổng số: </i> <label>{{ totalTraCuu }}</label>
          </span>
          <v-pagination
            :total-visible="7"
            :length="lengthPageTraCuuThongKe"
            v-model="pageTraCuuThongKe"
            @input="pagingTraCuu"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </div>
    <v-layout row wrap class="ml-0">
      <!-- <v-flex xs12 sm12>
            <div style=" overflow-x: auto;" >
              <div>
                <v-data-table
                :headers="headers"
                :items="lists"
                hide-actions
                no-data-text = "Không có dữ liệu"
                :hide-default-header="false"
                hide-default-footer
                >
              </v-data-table>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <tiny-pagination :page="page" :pagesize="pageSize" @tiny:change-page="paggingData" :total="totalTraCuu"/>
        </v-flex> -->
      <v-flex xs12 sm12>
        <div
          v-show="loadingTableTraCuu"
          class="text-xs-center"
          style="width: 100%; background: #fff"
        >
          <v-progress-circular
            indeterminate
            v-bind:size="30"
            v-bind:width="2"
            color="purple"
          ></v-progress-circular>
          <br />
          Đang tải dữ liệu
        </div>
        <v-data-table
          :headers="headersTraCuu"
          :items="listsTraCuu"
          :loading="loadingTableTraCuu"
          loading-text="Đang tải dữ liệu, vui lòng chờ giây lát!"
          no-data-text="Không có dữ liệu"
          :hide-default-header="false"
          hide-default-footer
          hide-actions
          v-show="!loadingTableTraCuu"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td
                v-for="(itemHeader, index) in headersTraCuu"
                class="text-xs-center"
              >
                <span v-if="itemHeader['display'] === 'stt'">{{
                  pageTraCuuThongKe * 20 - 20 + props.index + 1
                }}</span>
                <div v-else-if="itemHeader['display'] === 'action'">
                  <!-- <v-chip label outline color="blue" v-if="checkMtCore(props.item)" @click="xemHoSo(props.item)">Xem hồ sơ</v-chip> <br> -->

                  <v-chip v-if="chooseTypeTraCuu === 'tt'"
                    small
                    label
                    outline
                    color="blue"
                    :disabled="
                      !props.item['deliverableFileEntryId'] ||
                      props.item['deliverableFileEntryId'] === '0'
                    "
                    @click="xemGiayChungNhan(props.item)"
                  >
                    <v-icon
                      size="17"
                      style="font-size: 15px"
                      :color="
                        props.item['vr_VehicleTypeCertificate'] &&
                        props.item['vr_VehicleTypeCertificate'][
                          'deliverableFileEntryId'
                        ] &&
                        props.item['vr_VehicleTypeCertificate'][
                          'deliverableFileEntryId'
                        ] !== '0'
                          ? 'green'
                          : 'red'
                      "
                    >
                      {{
                        props.item["vr_VehicleTypeCertificate"] &&
                        props.item["vr_VehicleTypeCertificate"][
                          "deliverableFileEntryId"
                        ] &&
                        props.item["vr_VehicleTypeCertificate"][
                          "deliverableFileEntryId"
                        ] !== "0"
                          ? "done"
                          : "cancel"
                      }}
                    </v-icon>
                    <span style="cursor: pointer">Xem GCN</span>
                  </v-chip>
                  <br v-if="chooseTypeTraCuu === 'tt'" />

                  <!-- <v-chip small label outline color="blue" v-if="checkMtCore(props.item)" @click="xemBienBan(props.item)">Xem biên bản</v-chip> <br> -->
                  <v-chip v-if="chooseTypeTraCuu === 'tt'"
                    small
                    label
                    outline
                    color="blue"
                    style="cursor: pointer"
                    @click="xemTSKT(props.item)"
                  >
                    <v-icon
                      size="17"
                      style="font-size: 15px"
                      :color="green">
                      {{
                        "done"
                      }}
                    </v-icon>
                    <span style="cursor: pointer">Xem TSKT</span>
                  </v-chip>
                  <br v-if="chooseTypeTraCuu === 'tt' && props.item['vr_VehicleTypeCertificate']['serviceCode'] === 'TT302011BGTVTTDTKXCG'" />
                  <v-chip v-if="chooseTypeTraCuu === 'tt' && props.item['vr_VehicleTypeCertificate']['serviceCode'] === 'TT302011BGTVTTDTKXCG'"
                    small
                    label
                    outline
                    color="blue"
                    style="cursor: pointer"
                    @click="viewBanVe(props.item)"
                  >
                    <v-icon
                      size="17"
                      style="font-size: 15px"
                      :color="green">
                      {{
                        "done"
                      }}
                    </v-icon>
                    <span style="cursor: pointer">Xem Bản Vẽ</span>
                  </v-chip>
                  <br v-if="chooseTypeTraCuu === 'tt'" />
                  <v-chip v-if="chooseTypeTraCuu === 'tt'"
                    small
                    label
                    outline
                    color="blue"
                    style="cursor: pointer"
                    @click="viewListAnh(props.item, 1)"
                  >
                    <v-icon
                      size="17"
                      style="font-size: 15px"
                      :color="green">
                      {{
                        "done"
                      }}
                    </v-icon>
                    <span style="cursor: pointer">Xem Ảnh SP</span>
                  </v-chip>
                  <v-chip v-if="chooseTypeTraCuu === 'dt'"
                    small
                    label
                    outline
                    color="blue"
                    style="cursor: pointer"
                    @click="xemThongTinPXX(props.item)"
                  >
                    <v-icon
                      size="17"
                      style="font-size: 15px"
                      :color="green">
                      {{
                        "done"
                      }}
                    </v-icon>
                    <span style="cursor: pointer">Xem Thông tin PXX</span>
                  </v-chip>
                  <v-chip v-if="chooseTypeTraCuu === 'dt'"
                    small
                    label
                    outline
                    color="blue"
                    style="cursor: pointer"
                    @click="xemTSKT2(props.item)"
                  >
                    <v-icon
                      size="17"
                      style="font-size: 15px"
                      :color="green">
                      {{
                        "done"
                      }}
                    </v-icon>
                    <span style="cursor: pointer">Xem TSKT</span>
                  </v-chip>
                  <v-chip v-if="chooseTypeTraCuu === 'dt'"
                    small
                    label
                    outline
                    color="blue"
                    style="cursor: pointer"
                    @click="viewBanVe(props.item)"
                  >
                    <v-icon
                      size="17"
                      style="font-size: 15px"
                      :color="green">
                      {{
                        "done"
                      }}
                    </v-icon>
                    <span style="cursor: pointer">Xem Bản Vẽ</span>
                  </v-chip>
                  <v-chip v-if="chooseTypeTraCuu === 'dt'"
                    small
                    label
                    outline
                    color="blue"
                    style="cursor: pointer"
                    @click="viewListAnh(props.item, 2)"
                  >
                    <v-icon
                      size="17"
                      style="font-size: 15px"
                      :color="green">
                      {{
                        "done"
                      }}
                    </v-icon>
                    <span style="cursor: pointer">Xem Ảnh SP</span>
                  </v-chip>
                </div>

                <span v-else-if="itemHeader['display'] === 'vr_VehicleTypeCertificate.certificateRecordNo' || itemHeader['display'] === 'vr_VehicleTypeCertificate.certificateRecordDate'">
                  <span v-if="props.item['vr_VehicleTypeCertificate'] && props.item['vr_VehicleTypeCertificate']['certificateRecordStatus'] === 2 || props.item['vr_VehicleTypeCertificate']['certificateRecordStatus'] === '2' || props.item['vr_VehicleTypeCertificate']['certificateRecordStatus'] === 3 || props.item['vr_VehicleTypeCertificate']['certificateRecordStatus'] === '3'">
                    {{getDisplay(props.item, itemHeader['display'], itemHeader['type'])}}
                  </span>
                </span>

                <span v-else-if="itemHeader['display'] === 'vr_VehicleTypeCertificate.urbanCycle' || itemHeader['display'] === 'vr_VehicleTypeCertificate.ruralCycle' || itemHeader['display'] === 'vr_VehicleTypeCertificate.combinedCycle'">
                  <span>
                    {{getDisplay2(props.item, itemHeader['display'], itemHeader['display2'])}}
                  </span>
                </span>

                <span v-else>{{
                  getDisplay(
                    props.item,
                    itemHeader["display"],
                    itemHeader["type"]
                  )
                }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialogTSKT"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title
          class=""
          style="
            height: 63px;
            background: #2c4577;
            color: #fff;
            font-size: 20px;
            position: relative;
          "
        >
          Thông số kỹ thuật
          <v-btn
            dark
            icon
            style="position: absolute; right: 19px"
            class="mx-0 my-0"
            v-on:click.native="dialogTSKT = false"
          >
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <div style="max-height: 690px; overflow: auto">
          <v-progress-linear
            v-if="loadingDialog"
            :indeterminate="true"
          ></v-progress-linear>
          <!-- tskt cũ -->

          <div>
            <!-- TODO detailTemplate page -->
            <div style="width: 100%; background: #fff;">

              <v-expansion-panel expand class="my-0 opencps-dossier-info">
                <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">
                  <v-flex xs12 sm3>
                    <span>Số chứng chỉ</span>: <label>{{thongTinChungTSKT['certificateRecordNo']}}</label>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <span>Ngày ký</span>: <label>{{parseTimeStampToDate(thongTinChungTSKT['certificateRecordDate'])}}</label>
                  </v-flex>
                  <v-flex xs12 sm6>

                  </v-flex>

                  <v-flex xs12 sm3>
                    <span>Đăng kiểm viên chính</span>: <label>{{thongTinChungTSKT['inspectorName'] || thongTinChungTSKT['inspectorSignName']}}</label>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <span>Số biên bản kiểm tra</span>: <label>{{thongTinChungTSKT['inspectionRecordNo'] || thongTinChungTSKT['verificationRefNo']}}</label>
                  </v-flex>
                  <v-flex xs12 sm6>

                  </v-flex>

                  <v-flex xs12 sm3>
                    <span>Ngày kiểm tra</span>: <label>{{thongTinChungTSKT['inspectionRecordNo'] ? parseTimeStampToDate(thongTinChungTSKT['inspectionDate']) : parseTimeStampToDate(thongTinChungTSKT['verificationRefDate'])}}</label>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <span>Loại hồ sơ</span>: <label>{{thongTinChungTSKT['dossierTypeDescription']}}</label>
                  </v-flex>
                  <v-flex xs12 sm6>

                  </v-flex>

                  <v-flex xs12 sm12 v-if="thongTinChungTSKT['serviceCode'] == 'TT302011BGTVTTDTKXCG' && thongTinChungTSKT['designModelDescription']">
                    Loại hình thiết kế: <label>{{thongTinChungTSKT['designModelDescription']}}</label>
                  </v-flex>

                  <template v-if="thongTinChungTSKT['serviceCode'] == 'TT302011BGTVTTDTKXCG'">
                    <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">

                      <v-flex xs12 sm12>
                        <label>1. THÔNG TIN CHUNG</label>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                          <thead>
                            <tr>
                              <th class="text-xs-center">TT</th>
                              <th class="text-xs-center">Hạng mục</th>
                              <th class="text-xs-center">Nội dung</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <label>1.</label>
                              </td>
                              <td colspan="2">
                                <label>Cơ sở thiết kế</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1. </td>
                              <td class="text-xs-left">Tên</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2. </td>
                              <td class="text-xs-left">Địa chỉ</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                            </tr>
                            <!-- <tr>
                              <td class="text-xs-left">1.3. </td>
                              <td class="text-xs-left">Người đại diện</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantRepresentative']}} <br>
                                {{thongTinChungTSKT['applicantRepresentativeTitle']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.4. </td>
                              <td class="text-xs-left">Số điện thoại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantPhone']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.5. </td>
                              <td class="text-xs-left">Thư điện tử (Email)</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantEmail']}}</td>
                            </tr> -->

                            <tr>
                              <td>
                                <label>2.</label>
                              </td>
                              <td colspan="2">
                                <label>Cơ sở sản xuất lắp ráp, nhập khẩu</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.1. </td>
                              <td class="text-xs-left">Tên</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['manufacturerName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.2. </td>
                              <td class="text-xs-left">Địa chỉ</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['manufacturerAddress']}}</td>
                            </tr>

                            <!-- <tr>
                              <td>
                                <label>3.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin tham chiếu</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.1. </td>
                              <td class="text-xs-left">Số tham chiếu của xe cơ sở (dùng cho loại hình sản xuất lắp ráp từ xe cơ sở)</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['baseCertificateRecordNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.2. </td>
                              <td class="text-xs-left">Số giấy chứng nhận tham chiếu (dùng cho cấp lại, mở rộng) (nếu có)</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                            </tr>

                            <tr>
                              <td>
                                <label>4.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin Quy chuẩn áp dụng</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.1. </td>
                              <td class="text-xs-left">Quy chuẩn an toàn chung</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.2. </td>
                              <td class="text-xs-left">Quy chuẩn khí thải</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                            </tr> -->

                            <tr>
                              <td>
                                <label>5.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin chung về kiểu loại xe</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.1. </td>
                              <td class="text-xs-left">Ký hiệu thiết kế</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['designSymbol']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.2. </td>
                              <td class="text-xs-left">Loại phương tiện</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3. </td>
                              <td class="text-xs-left">Nhãn hiệu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.4. </td>
                              <td class="text-xs-left">Tên thương mại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.5. </td>
                              <td class="text-xs-left">Mã kiểu loại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                            </tr>

                          </tbody>
                        </table>

                      </v-flex>
                    </v-layout>
                  </template>

                  <template v-else-if="listServiceToanXe.includes(thongTinChungTSKT['serviceCode'])">
                    <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">

                      <v-flex xs12 sm12>
                        <label>1. THÔNG TIN CHUNG</label>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                          <thead>
                            <tr>
                              <th class="text-xs-center">TT</th>
                              <th class="text-xs-center">Hạng mục</th>
                              <th class="text-xs-center">Nội dung</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <label>1.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin về cơ sở sản xuất</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1. </td>
                              <td class="text-xs-left">Cơ sở sản xuất, lắp ráp</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1.1 </td>
                              <td class="text-xs-left">Địa chỉ</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                            </tr>
                            <!-- <tr>
                              <td class="text-xs-left">1.1.2 </td>
                              <td class="text-xs-left">Người đại diện</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantRepresentative']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1.2.1 </td>
                              <td class="text-xs-left">Chức danh</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantRepresentativeTitle']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1.2.2 </td>
                              <td class="text-xs-left">Số điện thoại</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantPhone']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1.2.3 </td>
                              <td class="text-xs-left">Thư điện tử</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantEmail']}}
                              </td>
                            </tr>


                            <tr>
                              <td class="text-xs-left">1.2 </td>
                              <td class="text-xs-left">Nhà máy sản xuất</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['productionPlantName']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.1</td>
                              <td class="text-xs-left">Địa chỉ nhà máy sản xuất</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['productionPlantAddress']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.2</td>
                              <td class="text-xs-left">Người đại diện</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['productionPlantRepresentative']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.2.1 </td>
                              <td class="text-xs-left">Chức danh</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['productionPlantRepresentativeTitle']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.2.2 </td>
                              <td class="text-xs-left">Số điện thoại</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactPhone']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.2.3 </td>
                              <td class="text-xs-left">Thư điện tử</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactEmail']}}
                              </td>
                            </tr>

                            <tr>
                              <td class="text-xs-left">1.3 </td>
                              <td class="text-xs-left">Người liên hệ</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactName']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.3.1 </td>
                              <td class="text-xs-left">Số điện thoại</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactTelNo']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.3.2 </td>
                              <td class="text-xs-left">Thư điện tử</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactEmail']}}
                              </td>
                            </tr>



                            <tr>
                              <td>
                                <label>2.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin về kết quả đánh giá COP</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.1. </td>
                              <td class="text-xs-left">Số báo cáo đánh giá COP</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['copReportNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.2. </td>
                              <td class="text-xs-left">Ngày báo cáo </td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['copReportDate'])}}</td>
                            </tr>


                            <tr>
                              <td class="text-xs-left">3. </td>
                              <td class="text-xs-left" colspan="2">Thông tin về loại hồ sơ và giấy chứng nhận xe</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.1. </td>
                              <td class="text-xs-left"> Loại hồ sơ xin cấp GCN</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['dossierTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.2. </td>
                              <td class="text-xs-left">Số GCN của loại xe gốc</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certificateRecordNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.2.1. </td>
                              <td class="text-xs-left">Ngày cấp</td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['certificateRecordDate'])}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.3. </td>
                              <td class="text-xs-left">Số GCN tham chiếu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                            </tr>

                            <tr>
                              <td>
                                <label>4.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin về chứng chỉ thẩm định thiết kế</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.1. </td>
                              <td class="text-xs-left">Số chứng chỉ thẩm định thiết kế</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['verificationCertificateNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.2. </td>
                              <td class="text-xs-left">Ngày cấp</td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['verificationCertificateDate'])}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.3. </td>
                              <td class="text-xs-left">Ký hiệu thiết kế</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['designSymbol']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.4. </td>
                              <td class="text-xs-left">Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['typeApprovalCertificateNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.4. </td>
                              <td class="text-xs-left">Ngày cấp</td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['typeApprovalCertificateDate'])}}</td>
                            </tr>





                            <tr>
                              <td>
                                <label>4.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin tiêu chuẩn, quy chuẩn áp dụng, Báo cáo kết quả thử nghiệm </label>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="3">
                                <label>4.1 Thông tin tiêu chuẩn, quy chuẩn áp dụng</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.1.1. </td>
                              <td class="text-xs-left">Tiêu chuẩn an toàn chung</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.1.2. </td>
                              <td class="text-xs-left">Tiêu chuẩn khí thải</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.2. </td>
                              <td class="text-xs-left">Báo cáo kết quả kiểm tra, thử nghiệm an toàn kỹ thuật và bảo vệ môi trường</td>
                            </tr>

                            <tr>
                              <td class="text-xs-left">4.2.1. </td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm an toàn 1/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['safetyTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['safetyTestReportDate'])}}</span>
                              </td>
                            </tr>

                            <tr>
                              <td class="text-xs-left"></td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm an toàn 2/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['secondSafetyTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['secondSafetyTestReportDate'])}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left"></td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm an toàn 3/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['thirdSafetyTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['thirdSafetyTestReportDate'])}}</span>
                              </td>
                            </tr>

                            <tr>
                              <td class="text-xs-left">4.2.2. </td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm môi trường 1/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['emissionTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['emissionTestReportDate'])}}</span>
                              </td>
                            </tr>

                            <tr>
                              <td class="text-xs-left"></td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm môi trường 2/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['secondEmissionTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['secondEmissionTestReportDate'])}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left"></td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm môi trường 3/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['thirdEmissionTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['thirdEmissionTestReportDate'])}}</span>
                              </td>
                            </tr>



                            <tr>
                              <td class="text-xs-left">4.2.3. </td>
                              <td class="text-xs-left">Báo cáo kết quả thử nghiệm liên quan khác </td>
                              <td class="text-xs-center"></td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.2.4. </td>
                              <td class="text-xs-left">Biên bản kiểm tra xác nhận/ ngày      /</td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['otherTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['otherTestReportDate'])}}</span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <label>5.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin xe mẫu</label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>5.1</label>
                              </td>
                              <td colspan="2">
                                <label>Xe mẫu thử nghiệm an toàn 1</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.1.1 </td>
                              <td class="text-xs-left">Số khung (số VIN)</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleVINNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.1.2</td>
                              <td class="text-xs-left">Số động cơ</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleEngineNo']}}</td>
                            </tr>
                            <tr>
                              <td>
                                <label>5.2</label>
                              </td>
                              <td colspan="2">
                                <label>Xe mẫu thử nghiệm an toàn 2</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.2.1 </td>
                              <td class="text-xs-left">Số khung (số VIN)</td>
                              <td class="text-xs-center"><!-- {{thongTinChungTSKT['sampleVINNo']}} --!></td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.2.2</td>
                              <td class="text-xs-left">Số động cơ</td>
                              <td class="text-xs-center"><!-- {{thongTinChungTSKT['sampleEngineNo']}} --!></td>
                            </tr>
                            <tr>
                              <td>
                                <label>5.3</label>
                              </td>
                              <td colspan="2">
                                <label>Xe mẫu thử nghiệm khí thải 1</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.1 </td>
                              <td class="text-xs-left">Số khung (số VIN)</td>
                              <td class="text-xs-center"><!-- {{thongTinChungTSKT['sampleVINNo']}} --!></td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.2</td>
                              <td class="text-xs-left">Số động cơ</td>
                              <td class="text-xs-center"><!-- {{thongTinChungTSKT['sampleEngineNo']}} --!></td>
                            </tr>
                            <tr>
                              <td>
                                <label>5.4</label>
                              </td>
                              <td colspan="2">
                                <label>Xe mẫu thử nghiệm khí thải 2</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.4.1 </td>
                              <td class="text-xs-left">Số khung (số VIN)</td>
                              <td class="text-xs-center"><!-- {{thongTinChungTSKT['sampleVINNo']}} --!></td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.4.2</td>
                              <td class="text-xs-left">Số động cơ</td>
                              <td class="text-xs-center"><!-- {{thongTinChungTSKT['sampleEngineNo']}} --!></td>
                            </tr> -->



                            <tr>
                              <td>
                                <label>6.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin chung về kiểu loại xe</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.1. </td>
                              <td class="text-xs-left">Loại phương tiện</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.2. </td>
                              <td class="text-xs-left">Nhãn hiệu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.3. </td>
                              <td class="text-xs-left">Tên thương mại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.4. </td>
                              <td class="text-xs-left">Mã kiểu loại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.5. </td>
                              <td class="text-xs-left">Loại hình sản xuất, lắp ráp</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedAssemblyTypeDescription']}}</td>
                            </tr>

                            <tr>
                              <td class="text-xs-left">6.6. </td>
                              <td class="text-xs-left">Mã số VIN</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedVINNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.6.1 </td>
                              <td class="text-xs-left">Mô tả vị trí đóng</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedVINPosition']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.7. </td>
                              <td class="text-xs-left">Mã số khung</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedFrameNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.7.1. </td>
                              <td class="text-xs-left">Nơi đóng số khung</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedFrameAttachPlace']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.8. </td>
                              <td class="text-xs-left">Mã số động cơ</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedEngineNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">6.8.1. </td>
                              <td class="text-xs-left">Nơi đóng số động cơ</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedEngineAttachPlace']}}</td>
                            </tr>

                          </tbody>
                        </table>

                      </v-flex>
                    </v-layout>
                  </template>

                  <template v-else-if="listServiceLinhKien.includes(thongTinChungTSKT['serviceCode'])">
                    <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">

                      <v-flex xs12 sm12>
                        <label>1. THÔNG TIN CHUNG</label>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                          <thead>
                            <tr>
                              <th class="text-xs-center">TT</th>
                              <th class="text-xs-center">Hạng mục</th>
                              <th class="text-xs-center">Nội dung</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <label>1.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin về cơ sở sản xuất</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1. </td>
                              <td class="text-xs-left">Cơ sở sản xuất, lắp ráp</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1.1 </td>
                              <td class="text-xs-left">Địa chỉ</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                            </tr>
                            <!-- <tr>
                              <td class="text-xs-left">1.1.2 </td>
                              <td class="text-xs-left">Người đại diện</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantRepresentative']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1.2.1 </td>
                              <td class="text-xs-left">Chức danh</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantRepresentativeTitle']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1.2.2 </td>
                              <td class="text-xs-left">Số điện thoại</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantPhone']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1.2.3 </td>
                              <td class="text-xs-left">Thư điện tử</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantEmail']}}
                              </td>
                            </tr>


                            <tr>
                              <td class="text-xs-left">1.2 </td>
                              <td class="text-xs-left">Nhà máy sản xuất</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['productionPlantName']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.1</td>
                              <td class="text-xs-left">Địa chỉ nhà máy sản xuất</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['productionPlantAddress']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.2</td>
                              <td class="text-xs-left">Người đại diện</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['productionPlantRepresentative']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.2.1 </td>
                              <td class="text-xs-left">Chức danh</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['productionPlantRepresentativeTitle']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.2.2 </td>
                              <td class="text-xs-left">Số điện thoại</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactPhone']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2.2.3 </td>
                              <td class="text-xs-left">Thư điện tử</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactEmail']}}
                              </td>
                            </tr>

                            <tr>
                              <td class="text-xs-left">1.3 </td>
                              <td class="text-xs-left">Người liên hệ</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactName']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.3.1 </td>
                              <td class="text-xs-left">Số điện thoại</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactTelNo']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.3.2 </td>
                              <td class="text-xs-left">Thư điện tử</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['applicantContactEmail']}}
                              </td>
                            </tr>



                            <tr>
                              <td>
                                <label>2.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin về kết quả đánh giá COP</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.1. </td>
                              <td class="text-xs-left">Số báo cáo đánh giá COP</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['copReportNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.2. </td>
                              <td class="text-xs-left">Ngày báo cáo </td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['copReportDate'])}}</td>
                            </tr>


                            <tr>
                              <td class="text-xs-left">3. </td>
                              <td class="text-xs-left" colspan="2">Thông tin về loại hồ sơ và giấy chứng nhận xe</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.1. </td>
                              <td class="text-xs-left"> Loại hồ sơ xin cấp GCN</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['dossierTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.2. </td>
                              <td class="text-xs-left">Số GCN của loại xe gốc</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certificateRecordNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.2.1. </td>
                              <td class="text-xs-left">Ngày cấp</td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['certificateRecordDate'])}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.3. </td>
                              <td class="text-xs-left">Số GCN tham chiếu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                            </tr>

                            <tr>
                              <td>
                                <label>4. </label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin tiêu chuẩn, quy chuẩn áp dụng, Báo cáo kết quả thử nghiệm </label>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="3">
                                <label>4.1 Thông tin tiêu chuẩn, quy chuẩn áp dụng</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.1.1. </td>
                              <td class="text-xs-left">Tiêu chuẩn an toàn chung</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.1.2. </td>
                              <td class="text-xs-left">Tiêu chuẩn khí thải</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.2. </td>
                              <td class="text-xs-left">Báo cáo kết quả kiểm tra, thử nghiệm an toàn kỹ thuật và bảo vệ môi trường</td>
                            </tr>

                            <tr>
                              <td class="text-xs-left">4.2.1. </td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm an toàn 1/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['safetyTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['safetyTestReportDate'])}}</span>
                              </td>
                            </tr>

                            <tr>
                              <td class="text-xs-left"></td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm an toàn 2/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['secondSafetyTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['secondSafetyTestReportDate'])}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left"></td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm an toàn 3/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['thirdSafetyTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['thirdSafetyTestReportDate'])}}</span>
                              </td>
                            </tr>

                            <tr>
                              <td class="text-xs-left">4.2.2. </td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm môi trường 1/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['emissionTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['emissionTestReportDate'])}}</span>
                              </td>
                            </tr>

                            <tr>
                              <td class="text-xs-left"></td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm môi trường 2/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['secondEmissionTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['secondEmissionTestReportDate'])}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left"></td>
                              <td class="text-xs-left">
                                Báo cáo kết quả thử nghiệm môi trường 3/ Ngày cấp
                              </td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['thirdEmissionTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['thirdEmissionTestReportDate'])}}</span>
                              </td>
                            </tr>



                            <tr>
                              <td class="text-xs-left">4.2.3. </td>
                              <td class="text-xs-left">Báo cáo kết quả thử nghiệm liên quan khác </td>
                              <td class="text-xs-center"></td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.2.4. </td>
                              <td class="text-xs-left">Biên bản kiểm tra xác nhận/ ngày      /</td>
                              <td class="text-xs-center">
                                <span>{{thongTinChungTSKT['otherTestReportNo']}}</span> <br>
                                <span>{{parseTimeStampToDate(thongTinChungTSKT['otherTestReportDate'])}}</span>
                              </td>
                            </tr> -->

                            <tr>
                              <td>
                                <label>5.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin chung về kiểu loại sản phẩm</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.1. </td>
                              <td class="text-xs-left">Loại sản phẩm</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.2. </td>
                              <td class="text-xs-left">Nhãn hiệu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3. </td>
                              <td class="text-xs-left">Tên thương mại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.4. </td>
                              <td class="text-xs-left">Mã kiểu loại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.5. </td>
                              <td class="text-xs-left">Loại hình sản xuất, lắp ráp</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedAssemblyTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.5. </td>
                              <td class="text-xs-left">Ký hiệu thiết kế/ ký hiệu sản phẩm</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['designSymbol']}}
                              </td>
                            </tr>

                          </tbody>
                        </table>

                      </v-flex>
                    </v-layout>
                  </template>

                  <template v-else-if="listServiceSPM.includes(thongTinChungTSKT['serviceCode'])">
                    <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">

                      <v-flex xs12 sm12>
                        <label>1. THÔNG TIN CHUNG</label>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                          <thead>
                            <tr>
                              <th class="text-xs-center">TT</th>
                              <th class="text-xs-center">Hạng mục</th>
                              <th class="text-xs-center">Nội dung</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <label>1.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin về cơ sở sản xuất</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1. </td>
                              <td class="text-xs-left">Cơ sở sản xuất, lắp ráp</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2. </td>
                              <td class="text-xs-left">Địa chỉ</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.3. </td>
                              <td class="text-xs-left">Nhà máy sản xuất</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['productionPlantName']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.4. </td>
                              <td class="text-xs-left">Địa chỉ nhà máy sản xuất</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['productionPlantAddress']}}</td>
                            </tr>

                            <tr>
                              <td>
                                <label>2.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin về chứng chỉ thẩm định thiết kế</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.1. </td>
                              <td class="text-xs-left">Số chứng chỉ thẩm định thiết kế</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['verificationCertificateNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.2. </td>
                              <td class="text-xs-left">Ngày cấp</td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['verificationCertificateDate'])}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.3. </td>
                              <td class="text-xs-left">Ký hiệu thiết kế</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['designSymbol']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.4. </td>
                              <td class="text-xs-left">Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['typeApprovalCertificateNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.4. </td>
                              <td class="text-xs-left">Ngày cấp</td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['typeApprovalCertificateDate'])}}</td>
                            </tr>

                            <tr>
                              <td>
                                <label>3.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin tiêu chuẩn, quy chuẩn áp dụng</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.1. </td>
                              <td class="text-xs-left">Tiêu chuẩn an toàn chung</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.2. </td>
                              <td class="text-xs-left">Tiêu chuẩn khí thải</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                            </tr>

                            <tr>
                              <td>
                                <label>4.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin chung về kiểu loại xe</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.1. </td>
                              <td class="text-xs-left">Loại hình sản xuất, lắp ráp</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedAssemblyTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.2. </td>
                              <td class="text-xs-left">Loại phương tiện</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3. </td>
                              <td class="text-xs-left">Nhãn hiệu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.4. </td>
                              <td class="text-xs-left">Tên thương mại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.5. </td>
                              <td class="text-xs-left">Mã kiểu loại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                            </tr>


                            <tr>
                              <td>
                                <label>5.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin xe mẫu, loại xe cở sở</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.1. </td>
                              <td class="text-xs-left">Số khung xe mẫu (số VIN)</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleVINNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.2. </td>
                              <td class="text-xs-left">Số động cơ xe mẫu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleEngineNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3. </td>
                              <td class="text-xs-left">Xe ô tô cơ sở (áp dụng cho xe đóng thùng)</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleVehicleTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.1 </td>
                              <td class="text-xs-left">Số GCN xe cơ sở</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.2 </td>
                              <td class="text-xs-left">Loại xe ô tô cơ sở</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleVehicleTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.3 </td>
                              <td class="text-xs-left">Nhãn hiệu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleTrademarkName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.4 </td>
                              <td class="text-xs-left">Tên thương mại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleCommercialName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.5 </td>
                              <td class="text-xs-left">Mã kiểu loại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleModelCode']}}</td>
                            </tr>
                          </tbody>
                        </table>

                      </v-flex>
                    </v-layout>
                  </template>

                  <template v-else>
                    <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">

                      <v-flex xs12 sm12>
                        <label>1. THÔNG TIN CHUNG</label>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                          <thead>
                            <tr>
                              <th class="text-xs-center">TT</th>
                              <th class="text-xs-center">Hạng mục</th>
                              <th class="text-xs-center">Nội dung</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <label>1.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin về cơ sở sản xuất</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.1. </td>
                              <td class="text-xs-left">Cơ sở sản xuất, lắp ráp</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.2. </td>
                              <td class="text-xs-left">Địa chỉ</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.3. </td>
                              <td class="text-xs-left">Nhà máy sản xuất</td>
                              <td class="text-xs-center">
                                {{thongTinChungTSKT['productionPlantName']}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">1.4. </td>
                              <td class="text-xs-left">Địa chỉ nhà máy sản xuất</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['productionPlantAddress']}}</td>
                            </tr>

                            <tr>
                              <td>
                                <label>2.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin về chứng chỉ thẩm định thiết kế</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.1. </td>
                              <td class="text-xs-left">Số chứng chỉ thẩm định thiết kế</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['verificationCertificateNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.2. </td>
                              <td class="text-xs-left">Ngày cấp</td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['verificationCertificateDate'])}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.3. </td>
                              <td class="text-xs-left">Ký hiệu thiết kế</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['designSymbol']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.4. </td>
                              <td class="text-xs-left">Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['typeApprovalCertificateNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">2.4. </td>
                              <td class="text-xs-left">Ngày cấp</td>
                              <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['typeApprovalCertificateDate'])}}</td>
                            </tr>

                            <tr>
                              <td>
                                <label>3.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin tiêu chuẩn, quy chuẩn áp dụng</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.1. </td>
                              <td class="text-xs-left">Tiêu chuẩn an toàn chung</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">3.2. </td>
                              <td class="text-xs-left">Tiêu chuẩn khí thải</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                            </tr>

                            <tr>
                              <td>
                                <label>4.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin chung về kiểu loại xe</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.1. </td>
                              <td class="text-xs-left">Loại hình sản xuất, lắp ráp</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedAssemblyTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.2. </td>
                              <td class="text-xs-left">Loại phương tiện</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3. </td>
                              <td class="text-xs-left">Nhãn hiệu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.4. </td>
                              <td class="text-xs-left">Tên thương mại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">4.5. </td>
                              <td class="text-xs-left">Mã kiểu loại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                            </tr>


                            <tr>
                              <td>
                                <label>5.</label>
                              </td>
                              <td colspan="2">
                                <label>Thông tin xe mẫu, loại xe cở sở</label>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.1. </td>
                              <td class="text-xs-left">Số khung xe mẫu (số VIN)</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleVINNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.2. </td>
                              <td class="text-xs-left">Số động cơ xe mẫu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleEngineNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3. </td>
                              <td class="text-xs-left">Xe ô tô cơ sở (áp dụng cho xe đóng thùng)</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleVehicleTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.1 </td>
                              <td class="text-xs-left">Số GCN xe cơ sở</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.2 </td>
                              <td class="text-xs-left">Loại xe ô tô cơ sở</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleVehicleTypeDescription']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.3 </td>
                              <td class="text-xs-left">Nhãn hiệu</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleTrademarkName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.4 </td>
                              <td class="text-xs-left">Tên thương mại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleCommercialName']}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left">5.3.5 </td>
                              <td class="text-xs-left">Mã kiểu loại</td>
                              <td class="text-xs-center">{{thongTinChungTSKT['sampleModelCode']}}</td>
                            </tr>
                          </tbody>
                        </table>

                      </v-flex>
                    </v-layout>
                  </template>

                  <v-flex xs12 sm12>
                    <label>2. THÔNG SỐ KỸ THUẬT SẢN PHẨM</label>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                      <thead>
                        <tr>
                          <th class="text-xs-center">TT</th>
                          <th class="text-xs-center">Hạng mục kiểm tra</th>
                          <th class="text-xs-center">Kết quả kiểm tra</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(item, index) in listThongSoKyThuat">
                          <tr :key="'listThongSoKyThuat' + index">
                            <td colspan="3" style="text-align: left!important;">
                              <label>{{item['title']}}</label>
                            </td>
                          </tr>
                          <tr v-for="(itemTSKT, indexTSKT) in item['items']" :key="'listThongSoKyThuat_item' + indexTSKT">
                            <td class="text-xs-center">
                              {{indexTSKT + 1}}
                            </td>
                            <td>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-html="itemTSKT['title']"></span>
                            </td>
                            <td class="text-xs-center">
                                {{itemTSKT['value']}}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </v-flex>

                  <v-flex xs12 sm12>
                    <label>3. GHI CHÚ</label>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                      <tbody>
                        <tr>
                          <td class="text-xs-left">
                            <span>3.1</span>
                          </td>
                          <td class="text-xs-left">
                            <span>Ghi chú để in chứng chỉ</span>
                          </td>
                          <td class="text-xs-left">
                            <span>{{thongTinChungTSKT['certificateNote']}}</span>
                          </td>
                        </tr>
                        <!-- <tr>
                          <td class="text-xs-left">
                            <span>3.2</span>
                          </td>
                          <td class="text-xs-left">
                            <span>Ghi chú khác</span>
                          </td>
                          <td class="text-xs-left">
                            <span>{{thongTinChungTSKT['inspectionNote']}}</span>
                          </td>
                        </tr> -->
                      </tbody>
                    </table>
                  </v-flex>

                  <!-- <v-flex xs12 sm12>
                    <label>4. HẠN XÁC NHẬN HIỆU LỰC</label>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                      <tr>
                        <th style="text-align: center;border: 0.5px solid;">TT</th>
                        <th style="text-align: center;border: 0.5px solid;">Số hồ sơ</th>
                        <th style="text-align: center;border: 0.5px solid;">Ngày hiệu lực</th>
                      </tr>
                      <tr v-for="(item, index) in dsHSXNHL" :key="'dshsxnhl' + index">
                        <td style=" text-align: center;border: 0.5px solid;">
                          {{index + 1}}
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <span v-if="item['validdossierid'] == -1">{{item['dossierno']}}</span>
                          <span v-else>{{item['validdossierno']}}</span>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          {{item['certificaterecordexpiredate']}}
                        </td>
                      </tr>
                    </table>
                  </v-flex>

                  <v-flex xs12 sm12 v-if="showTongThanhTSKT">
                    <label>5. DANH MỤC TỔNG THÀNH HỆ THỐNG</label>
                  </v-flex>
                  <v-flex xs12 sm12 v-if="showTongThanhTSKT">
                    <label>Danh mục tổng thành phải kiểm tra chứng nhận</label>
                    <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                      <thead>
                        <tr>
                          <th class="text-xs-center">TT</th>
                          <th class="text-xs-center">Tổng thành, hệ thống</th>
                          <th class="text-xs-center">Số GCN</th>
                          <th class="text-xs-center">Nhãn hiệu, số loại/ mã hiệu</th>
                          <th class="text-xs-center">Nguồn gốc</th>
                          <th class="text-xs-center">Nước sản xuất</th>
                        </tr>
                      </thead>
                      <tr v-for="(item, index) in vr_VehicleEquipment_BatBuoc" :key="'tongthanhhethongbatbuoc' + index">
                        <td style=" text-align: center;border: 0.5px solid;">
                          {{index + 1}}
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <span>{{item['certifiedVehicleTypeDescription']}}</span>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <span>{{item['certificateRecordNo']}}</span> <br>
                          <span>{{parseTimeStampToDate(item['certificateRecordDate'])}}</span>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <span>{{item['certifiedTrademarkName']}}</span>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <span>{{item['originalName']}}</span>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          {{item['productionCountry']}}
                        </td>
                      </tr>
                    </table>

                    <label>Danh mục tổng thành không phải kiểm tra chứng nhận</label>
                    <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                      <thead>
                        <tr>
                          <th class="text-xs-center">TT</th>
                          <th class="text-xs-center">Tổng thành, hệ thống</th>
                          <th class="text-xs-center">Số BCTN</th>
                          <th class="text-xs-center">Nhãn hiệu, số loại/ mã hiệu</th>
                          <th class="text-xs-center">Nguồn gốc</th>
                          <th class="text-xs-center">Nơi sản xuất</th>
                          <th class="text-xs-center">Nước sản xuất</th>
                        </tr>
                      </thead>
                      <tr v-for="(item, index) in vr_VehicleEquipment_KoBatBuoc" :key="'tongthanhhethongkobatbuoc' + index">
                        <td style=" text-align: center;border: 0.5px solid;">
                          {{index + 1}}
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <span>{{item['certifiedVehicleTypeDescription']}}</span>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <span>{{item['safetytestReportNo']}}</span> <br>
                          <span>{{parseTimeStampToDate(item['safetytestReportDate'])}}</span>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <span>{{item['certifiedTrademarkName']}}</span>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <span>{{item['originalName']}}</span>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          <template v-if="item['originalName'] == 3">
                            <div>
                              <span>{{item['manufacturerName']}}</span> <br>
                              <span>{{item['manufacturerAddress']}}</span>
                            </div>
                          </template>
                          <template v-else>
                            <div>
                              <span>{{item['productionName']}}</span> <br>
                              <span>{{item['productionAddress']}}</span>
                            </div>
                          </template>
                        </td>
                        <td style=" text-align: center;border: 0.5px solid;">
                          {{item['productionCountry']}}
                        </td>
                      </tr>
                    </table>
                  </v-flex> -->
                </v-layout>
              </v-expansion-panel>

            </div>

          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>

  <div v-else-if="detailPage == 2" style="width: 100%; background: #fff;">

    <div class="row-header">
      <div class="background-triangle-big"> KẾT QUẢ </div>
      <div class="layout row wrap header_tools row-blue">

        <div class="flex xs7 sm9 solo pl-4 pt-2 text-ellipsis">

          THÔNG SỐ KỸ THUẬT {{tenModuleTSKT}}

        </div>
        <div class="flex xs5 sm3 text-right" style="margin-left: auto;">

          <v-btn flat class=" my-0 py-0 btn-border-left" color="grey darken-1" v-on:click.native.prevent.stop="undoDetailPageTSKT()">
            <v-icon class="mr-2">undo</v-icon>
            Quay lại
          </v-btn>
        </div>

      </div>

    </div>

    <v-expansion-panel expand class="my-0 opencps-dossier-info">
      <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">
        <v-flex xs12 sm3>
          <span>Số chứng chỉ</span>: <label>{{thongTinChungTSKT['certificateRecordNo']}}</label>
        </v-flex>
        <v-flex xs12 sm3>
          <span>Ngày ký</span>: <label>{{parseTimeStampToDate(thongTinChungTSKT['certificateRecordDate'])}}</label>
        </v-flex>
        <v-flex xs12 sm6>

        </v-flex>

        <v-flex xs12 sm3>
          <span>Đăng kiểm viên chính</span>: <label>{{thongTinChungTSKT['inspectorName'] || thongTinChungTSKT['inspectorSignName']}}</label>
        </v-flex>
        <v-flex xs12 sm3>
          <span>Số biên bản kiểm tra</span>: <label>{{thongTinChungTSKT['inspectionRecordNo'] || thongTinChungTSKT['verificationRefNo']}}</label>
        </v-flex>
        <v-flex xs12 sm6>

        </v-flex>

        <v-flex xs12 sm3>
          <span>Ngày kiểm tra</span>: <label>{{thongTinChungTSKT['inspectionRecordNo'] ? parseTimeStampToDate(thongTinChungTSKT['inspectionDate']) : parseTimeStampToDate(thongTinChungTSKT['verificationRefDate'])}}</label>
        </v-flex>
        <v-flex xs12 sm3>
          <span>Loại hồ sơ</span>: <label>{{thongTinChungTSKT['dossierTypeDescription']}}</label>
        </v-flex>
        <v-flex xs12 sm6>

        </v-flex>

        <v-flex xs12 sm12 v-if="thongTinChungTSKT['serviceCode'] == 'TT302011BGTVTTDTKXCG' && thongTinChungTSKT['designModelDescription']">
          Loại hình thiết kế: <label>{{thongTinChungTSKT['designModelDescription']}}</label>
        </v-flex>

        <template v-if="thongTinChungTSKT['serviceCode'] == 'TT302011BGTVTTDTKXCG'">
          <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">
            
            <v-flex xs12 sm12>
              <label>1. THÔNG TIN CHUNG</label>
            </v-flex>
            <v-flex xs12 sm12>
              <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                <thead>
                  <tr>
                      <th class="text-xs-center">TT</th>
                      <th class="text-xs-center">Hạng mục</th>
                      <th class="text-xs-center">Nội dung</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <label>1.</label>
                    </td>
                    <td colspan="2">
                      <label>Cơ sở thiết kế</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1. </td>
                    <td class="text-xs-left">Tên</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2. </td>
                    <td class="text-xs-left">Địa chỉ</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                  </tr>
                  <!-- <tr>
                    <td class="text-xs-left">1.3. </td>
                    <td class="text-xs-left">Người đại diện</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantRepresentative']}} <br>
                      {{thongTinChungTSKT['applicantRepresentativeTitle']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.4. </td>
                    <td class="text-xs-left">Số điện thoại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantPhone']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.5. </td>
                    <td class="text-xs-left">Thư điện tử (Email)</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantEmail']}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>2.</label>
                    </td>
                    <td colspan="2">
                      <label>Cơ sở sản xuất lắp ráp, nhập khẩu</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.1. </td>
                    <td class="text-xs-left">Tên</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['manufacturerName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.2. </td>
                    <td class="text-xs-left">Địa chỉ</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['manufacturerAddress']}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>3.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin tham chiếu</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.1. </td>
                    <td class="text-xs-left">Số tham chiếu của xe cơ sở (dùng cho loại hình sản xuất lắp ráp từ xe cơ sở)</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['baseCertificateRecordNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.2. </td>
                    <td class="text-xs-left">Số giấy chứng nhận tham chiếu (dùng cho cấp lại, mở rộng) (nếu có)</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>4.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin Quy chuẩn áp dụng</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.1. </td>
                    <td class="text-xs-left">Quy chuẩn an toàn chung</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.2. </td>
                    <td class="text-xs-left">Quy chuẩn khí thải</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                  </tr> -->

                  <tr>
                    <td>
                      <label>5.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin chung về kiểu loại xe</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.1. </td>
                    <td class="text-xs-left">Ký hiệu thiết kế</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['designSymbol']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.2. </td>
                    <td class="text-xs-left">Loại phương tiện</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3. </td>
                    <td class="text-xs-left">Nhãn hiệu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.4. </td>
                    <td class="text-xs-left">Tên thương mại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.5. </td>
                    <td class="text-xs-left">Mã kiểu loại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                  </tr>

                </tbody>
              </table>

            </v-flex>
          </v-layout>
        </template>

        <template v-else-if="listServiceToanXe.includes(thongTinChungTSKT['serviceCode'])">
          <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">

            <v-flex xs12 sm12>
              <label>1. THÔNG TIN CHUNG</label>
            </v-flex>
            <v-flex xs12 sm12>
              <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                <thead>
                  <tr>
                    <th class="text-xs-center">TT</th>
                    <th class="text-xs-center">Hạng mục</th>
                    <th class="text-xs-center">Nội dung</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <label>1.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin về cơ sở sản xuất</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1. </td>
                    <td class="text-xs-left">Cơ sở sản xuất, lắp ráp</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1.1 </td>
                    <td class="text-xs-left">Địa chỉ</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                  </tr>
                  <!-- <tr>
                    <td class="text-xs-left">1.1.2 </td>
                    <td class="text-xs-left">Người đại diện</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantRepresentative']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1.2.1 </td>
                    <td class="text-xs-left">Chức danh</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantRepresentativeTitle']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1.2.2 </td>
                    <td class="text-xs-left">Số điện thoại</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantPhone']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1.2.3 </td>
                    <td class="text-xs-left">Thư điện tử</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantEmail']}}
                    </td>
                  </tr>


                  <tr>
                    <td class="text-xs-left">1.2 </td>
                    <td class="text-xs-left">Nhà máy sản xuất</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['productionPlantName']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.1</td>
                    <td class="text-xs-left">Địa chỉ nhà máy sản xuất</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['productionPlantAddress']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.2</td>
                    <td class="text-xs-left">Người đại diện</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['productionPlantRepresentative']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.2.1 </td>
                    <td class="text-xs-left">Chức danh</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['productionPlantRepresentativeTitle']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.2.2 </td>
                    <td class="text-xs-left">Số điện thoại</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactPhone']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.2.3 </td>
                    <td class="text-xs-left">Thư điện tử</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactEmail']}}
                    </td>
                  </tr>

                  <tr>
                    <td class="text-xs-left">1.3 </td>
                    <td class="text-xs-left">Người liên hệ</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactName']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.3.1 </td>
                    <td class="text-xs-left">Số điện thoại</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactTelNo']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.3.2 </td>
                    <td class="text-xs-left">Thư điện tử</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactEmail']}}
                    </td>
                  </tr>



                  <tr>
                    <td>
                      <label>2.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin về kết quả đánh giá COP</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.1. </td>
                    <td class="text-xs-left">Số báo cáo đánh giá COP</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['copReportNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.2. </td>
                    <td class="text-xs-left">Ngày báo cáo </td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['copReportDate'])}}</td>
                  </tr>


                  <tr>
                    <td class="text-xs-left">3. </td>
                    <td class="text-xs-left" colspan="2">Thông tin về loại hồ sơ và giấy chứng nhận xe</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.1. </td>
                    <td class="text-xs-left"> Loại hồ sơ xin cấp GCN</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['dossierTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.2. </td>
                    <td class="text-xs-left">Số GCN của loại xe gốc</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certificateRecordNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.2.1. </td>
                    <td class="text-xs-left">Ngày cấp</td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['certificateRecordDate'])}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.3. </td>
                    <td class="text-xs-left">Số GCN tham chiếu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>4.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin về chứng chỉ thẩm định thiết kế</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.1. </td>
                    <td class="text-xs-left">Số chứng chỉ thẩm định thiết kế</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['verificationCertificateNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.2. </td>
                    <td class="text-xs-left">Ngày cấp</td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['verificationCertificateDate'])}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.3. </td>
                    <td class="text-xs-left">Ký hiệu thiết kế</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['designSymbol']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.4. </td>
                    <td class="text-xs-left">Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['typeApprovalCertificateNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.4. </td>
                    <td class="text-xs-left">Ngày cấp</td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['typeApprovalCertificateDate'])}}</td>
                  </tr>





                  <tr>
                    <td>
                      <label>4.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin tiêu chuẩn, quy chuẩn áp dụng, Báo cáo kết quả thử nghiệm </label>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <label>4.1 Thông tin tiêu chuẩn, quy chuẩn áp dụng</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.1.1. </td>
                    <td class="text-xs-left">Tiêu chuẩn an toàn chung</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.1.2. </td>
                    <td class="text-xs-left">Tiêu chuẩn khí thải</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.2. </td>
                    <td class="text-xs-left">Báo cáo kết quả kiểm tra, thử nghiệm an toàn kỹ thuật và bảo vệ môi trường</td>
                  </tr>

                  <tr>
                    <td class="text-xs-left">4.2.1. </td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm an toàn 1/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['safetyTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['safetyTestReportDate'])}}</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-xs-left"></td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm an toàn 2/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['secondSafetyTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['secondSafetyTestReportDate'])}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left"></td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm an toàn 3/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['thirdSafetyTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['thirdSafetyTestReportDate'])}}</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-xs-left">4.2.2. </td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm môi trường 1/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['emissionTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['emissionTestReportDate'])}}</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-xs-left"></td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm môi trường 2/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['secondEmissionTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['secondEmissionTestReportDate'])}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left"></td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm môi trường 3/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['thirdEmissionTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['thirdEmissionTestReportDate'])}}</span>
                    </td>
                  </tr>



                  <tr>
                    <td class="text-xs-left">4.2.3. </td>
                    <td class="text-xs-left">Báo cáo kết quả thử nghiệm liên quan khác </td>
                    <td class="text-xs-center"></td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.2.4. </td>
                    <td class="text-xs-left">Biên bản kiểm tra xác nhận/ ngày      /</td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['otherTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['otherTestReportDate'])}}</span>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <label>5.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin xe mẫu</label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>5.1</label>
                    </td>
                    <td colspan="2">
                      <label>Xe mẫu thử nghiệm an toàn 1</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.1.1 </td>
                    <td class="text-xs-left">Số khung (số VIN)</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleVINNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.1.2</td>
                    <td class="text-xs-left">Số động cơ</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleEngineNo']}}</td>
                  </tr>
                  <tr>
                    <td>
                      <label>5.2</label>
                    </td>
                    <td colspan="2">
                      <label>Xe mẫu thử nghiệm an toàn 2</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.2.1 </td>
                    <td class="text-xs-left">Số khung (số VIN)</td>
                    <td class="text-xs-center"><#-- {{thongTinChungTSKT['sampleVINNo']}} --!></td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.2.2</td>
                    <td class="text-xs-left">Số động cơ</td>
                    <td class="text-xs-center"><#-- {{thongTinChungTSKT['sampleEngineNo']}} --!></td>
                  </tr>
                  <tr>
                    <td>
                      <label>5.3</label>
                    </td>
                    <td colspan="2">
                      <label>Xe mẫu thử nghiệm khí thải 1</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.1 </td>
                    <td class="text-xs-left">Số khung (số VIN)</td>
                    <td class="text-xs-center"><#-- {{thongTinChungTSKT['sampleVINNo']}} --!></td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.2</td>
                    <td class="text-xs-left">Số động cơ</td>
                    <td class="text-xs-center"><#-- {{thongTinChungTSKT['sampleEngineNo']}} --!></td>
                  </tr>
                  <tr>
                    <td>
                      <label>5.4</label>
                    </td>
                    <td colspan="2">
                      <label>Xe mẫu thử nghiệm khí thải 2</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.4.1 </td>
                    <td class="text-xs-left">Số khung (số VIN)</td>
                    <td class="text-xs-center"><#-- {{thongTinChungTSKT['sampleVINNo']}} --!></td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.4.2</td>
                    <td class="text-xs-left">Số động cơ</td>
                    <td class="text-xs-center"><#-- {{thongTinChungTSKT['sampleEngineNo']}} --!></td>
                  </tr> -->



                  <tr>
                    <td>
                      <label>6.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin chung về kiểu loại xe</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.1. </td>
                    <td class="text-xs-left">Loại phương tiện</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.2. </td>
                    <td class="text-xs-left">Nhãn hiệu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.3. </td>
                    <td class="text-xs-left">Tên thương mại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.4. </td>
                    <td class="text-xs-left">Mã kiểu loại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.5. </td>
                    <td class="text-xs-left">Loại hình sản xuất, lắp ráp</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedAssemblyTypeDescription']}}</td>
                  </tr>

                  <tr>
                    <td class="text-xs-left">6.6. </td>
                    <td class="text-xs-left">Mã số VIN</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedVINNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.6.1 </td>
                    <td class="text-xs-left">Mô tả vị trí đóng</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedVINPosition']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.7. </td>
                    <td class="text-xs-left">Mã số khung</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedFrameNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.7.1. </td>
                    <td class="text-xs-left">Nơi đóng số khung</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedFrameAttachPlace']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.8. </td>
                    <td class="text-xs-left">Mã số động cơ</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedEngineNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">6.8.1. </td>
                    <td class="text-xs-left">Nơi đóng số động cơ</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedEngineAttachPlace']}}</td>
                  </tr>
                  
                </tbody>
              </table>

            </v-flex>
          </v-layout>
        </template>

        <template v-else-if="listServiceLinhKien.includes(thongTinChungTSKT['serviceCode'])">
          <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">

            <v-flex xs12 sm12>
              <label>1. THÔNG TIN CHUNG</label>
            </v-flex>
            <v-flex xs12 sm12>
              <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                <thead>
                  <tr>
                    <th class="text-xs-center">TT</th>
                    <th class="text-xs-center">Hạng mục</th>
                    <th class="text-xs-center">Nội dung</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <label>1.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin về cơ sở sản xuất</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1. </td>
                    <td class="text-xs-left">Cơ sở sản xuất, lắp ráp</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1.1 </td>
                    <td class="text-xs-left">Địa chỉ</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                  </tr>
                  <!-- <tr>
                    <td class="text-xs-left">1.1.2 </td>
                    <td class="text-xs-left">Người đại diện</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantRepresentative']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1.2.1 </td>
                    <td class="text-xs-left">Chức danh</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantRepresentativeTitle']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1.2.2 </td>
                    <td class="text-xs-left">Số điện thoại</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantPhone']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1.2.3 </td>
                    <td class="text-xs-left">Thư điện tử</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantEmail']}}
                    </td>
                  </tr>


                  <tr>
                    <td class="text-xs-left">1.2 </td>
                    <td class="text-xs-left">Nhà máy sản xuất</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['productionPlantName']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.1</td>
                    <td class="text-xs-left">Địa chỉ nhà máy sản xuất</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['productionPlantAddress']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.2</td>
                    <td class="text-xs-left">Người đại diện</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['productionPlantRepresentative']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.2.1 </td>
                    <td class="text-xs-left">Chức danh</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['productionPlantRepresentativeTitle']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.2.2 </td>
                    <td class="text-xs-left">Số điện thoại</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactPhone']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2.2.3 </td>
                    <td class="text-xs-left">Thư điện tử</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactEmail']}}
                    </td>
                  </tr>

                  <tr>
                    <td class="text-xs-left">1.3 </td>
                    <td class="text-xs-left">Người liên hệ</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactName']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.3.1 </td>
                    <td class="text-xs-left">Số điện thoại</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactTelNo']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.3.2 </td>
                    <td class="text-xs-left">Thư điện tử</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['applicantContactEmail']}}
                    </td>
                  </tr>



                  <tr>
                    <td>
                      <label>2.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin về kết quả đánh giá COP</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.1. </td>
                    <td class="text-xs-left">Số báo cáo đánh giá COP</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['copReportNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.2. </td>
                    <td class="text-xs-left">Ngày báo cáo </td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['copReportDate'])}}</td>
                  </tr>


                  <tr>
                    <td class="text-xs-left">3. </td>
                    <td class="text-xs-left" colspan="2">Thông tin về loại hồ sơ và giấy chứng nhận xe</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.1. </td>
                    <td class="text-xs-left"> Loại hồ sơ xin cấp GCN</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['dossierTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.2. </td>
                    <td class="text-xs-left">Số GCN của loại xe gốc</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certificateRecordNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.2.1. </td>
                    <td class="text-xs-left">Ngày cấp</td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['certificateRecordDate'])}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.3. </td>
                    <td class="text-xs-left">Số GCN tham chiếu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>4. </label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin tiêu chuẩn, quy chuẩn áp dụng, Báo cáo kết quả thử nghiệm </label>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <label>4.1 Thông tin tiêu chuẩn, quy chuẩn áp dụng</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.1.1. </td>
                    <td class="text-xs-left">Tiêu chuẩn an toàn chung</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.1.2. </td>
                    <td class="text-xs-left">Tiêu chuẩn khí thải</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.2. </td>
                    <td class="text-xs-left">Báo cáo kết quả kiểm tra, thử nghiệm an toàn kỹ thuật và bảo vệ môi trường</td>
                  </tr>

                  <tr>
                    <td class="text-xs-left">4.2.1. </td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm an toàn 1/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['safetyTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['safetyTestReportDate'])}}</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-xs-left"></td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm an toàn 2/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['secondSafetyTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['secondSafetyTestReportDate'])}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left"></td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm an toàn 3/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['thirdSafetyTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['thirdSafetyTestReportDate'])}}</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-xs-left">4.2.2. </td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm môi trường 1/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['emissionTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['emissionTestReportDate'])}}</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-xs-left"></td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm môi trường 2/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['secondEmissionTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['secondEmissionTestReportDate'])}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left"></td>
                    <td class="text-xs-left"> 
                      Báo cáo kết quả thử nghiệm môi trường 3/ Ngày cấp
                    </td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['thirdEmissionTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['thirdEmissionTestReportDate'])}}</span>
                    </td>
                  </tr>



                  <tr>
                    <td class="text-xs-left">4.2.3. </td>
                    <td class="text-xs-left">Báo cáo kết quả thử nghiệm liên quan khác </td>
                    <td class="text-xs-center"></td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.2.4. </td>
                    <td class="text-xs-left">Biên bản kiểm tra xác nhận/ ngày      /</td>
                    <td class="text-xs-center">
                      <span>{{thongTinChungTSKT['otherTestReportNo']}}</span> <br>
                      <span>{{parseTimeStampToDate(thongTinChungTSKT['otherTestReportDate'])}}</span>
                    </td>
                  </tr> -->

                  <tr>
                    <td>
                      <label>5.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin chung về kiểu loại sản phẩm</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.1. </td>
                    <td class="text-xs-left">Loại sản phẩm</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.2. </td>
                    <td class="text-xs-left">Nhãn hiệu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3. </td>
                    <td class="text-xs-left">Tên thương mại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.4. </td>
                    <td class="text-xs-left">Mã kiểu loại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.5. </td>
                    <td class="text-xs-left">Loại hình sản xuất, lắp ráp</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedAssemblyTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.5. </td>
                    <td class="text-xs-left">Ký hiệu thiết kế/ ký hiệu sản phẩm</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['designSymbol']}}
                    </td>
                  </tr>
                  
                </tbody>
              </table>

            </v-flex>
          </v-layout>
        </template>

        <template v-else-if="listServiceSPM.includes(thongTinChungTSKT['serviceCode'])">
          <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">

            <v-flex xs12 sm12>
              <label>1. THÔNG TIN CHUNG</label>
            </v-flex>
            <v-flex xs12 sm12>
              <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                <thead>
                  <tr>
                    <th class="text-xs-center">TT</th>
                    <th class="text-xs-center">Hạng mục</th>
                    <th class="text-xs-center">Nội dung</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <label>1.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin về cơ sở sản xuất</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1. </td>
                    <td class="text-xs-left">Cơ sở sản xuất, lắp ráp</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2. </td>
                    <td class="text-xs-left">Địa chỉ</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.3. </td>
                    <td class="text-xs-left">Nhà máy sản xuất</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['productionPlantName']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.4. </td>
                    <td class="text-xs-left">Địa chỉ nhà máy sản xuất</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['productionPlantAddress']}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>2.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin về chứng chỉ thẩm định thiết kế</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.1. </td>
                    <td class="text-xs-left">Số chứng chỉ thẩm định thiết kế</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['verificationCertificateNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.2. </td>
                    <td class="text-xs-left">Ngày cấp</td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['verificationCertificateDate'])}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.3. </td>
                    <td class="text-xs-left">Ký hiệu thiết kế</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['designSymbol']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.4. </td>
                    <td class="text-xs-left">Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['typeApprovalCertificateNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.4. </td>
                    <td class="text-xs-left">Ngày cấp</td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['typeApprovalCertificateDate'])}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>3.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin tiêu chuẩn, quy chuẩn áp dụng</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.1. </td>
                    <td class="text-xs-left">Tiêu chuẩn an toàn chung</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.2. </td>
                    <td class="text-xs-left">Tiêu chuẩn khí thải</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>4.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin chung về kiểu loại xe</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.1. </td>
                    <td class="text-xs-left">Loại hình sản xuất, lắp ráp</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedAssemblyTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.2. </td>
                    <td class="text-xs-left">Loại phương tiện</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3. </td>
                    <td class="text-xs-left">Nhãn hiệu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.4. </td>
                    <td class="text-xs-left">Tên thương mại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.5. </td>
                    <td class="text-xs-left">Mã kiểu loại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                  </tr>


                  <tr>
                    <td>
                      <label>5.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin xe mẫu, loại xe cở sở</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.1. </td>
                    <td class="text-xs-left">Số khung xe mẫu (số VIN)</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleVINNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.2. </td>
                    <td class="text-xs-left">Số động cơ xe mẫu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleEngineNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3. </td>
                    <td class="text-xs-left">Xe ô tô cơ sở (áp dụng cho xe đóng thùng)</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleVehicleTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.1 </td>
                    <td class="text-xs-left">Số GCN xe cơ sở</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.2 </td>
                    <td class="text-xs-left">Loại xe ô tô cơ sở</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleVehicleTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.3 </td>
                    <td class="text-xs-left">Nhãn hiệu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleTrademarkName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.4 </td>
                    <td class="text-xs-left">Tên thương mại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleCommercialName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.5 </td>
                    <td class="text-xs-left">Mã kiểu loại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleModelCode']}}</td>
                  </tr>
                </tbody>
              </table>

            </v-flex>
          </v-layout>
        </template>

        <template v-else>
          <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">

            <v-flex xs12 sm12>
              <label>1. THÔNG TIN CHUNG</label>
            </v-flex>
            <v-flex xs12 sm12>
              <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
                <thead>
                  <tr>
                    <th class="text-xs-center">TT</th>
                    <th class="text-xs-center">Hạng mục</th>
                    <th class="text-xs-center">Nội dung</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <label>1.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin về cơ sở sản xuất</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.1. </td>
                    <td class="text-xs-left">Cơ sở sản xuất, lắp ráp</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.2. </td>
                    <td class="text-xs-left">Địa chỉ</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['applicantAddress']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.3. </td>
                    <td class="text-xs-left">Nhà máy sản xuất</td>
                    <td class="text-xs-center">
                      {{thongTinChungTSKT['productionPlantName']}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">1.4. </td>
                    <td class="text-xs-left">Địa chỉ nhà máy sản xuất</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['productionPlantAddress']}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>2.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin về chứng chỉ thẩm định thiết kế</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.1. </td>
                    <td class="text-xs-left">Số chứng chỉ thẩm định thiết kế</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['verificationCertificateNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.2. </td>
                    <td class="text-xs-left">Ngày cấp</td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['verificationCertificateDate'])}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.3. </td>
                    <td class="text-xs-left">Ký hiệu thiết kế</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['designSymbol']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.4. </td>
                    <td class="text-xs-left">Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['typeApprovalCertificateNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">2.4. </td>
                    <td class="text-xs-left">Ngày cấp</td>
                    <td class="text-xs-center">{{parseTimeStampToDate(thongTinChungTSKT['typeApprovalCertificateDate'])}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>3.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin tiêu chuẩn, quy chuẩn áp dụng</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.1. </td>
                    <td class="text-xs-left">Tiêu chuẩn an toàn chung</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['commonSafetyDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">3.2. </td>
                    <td class="text-xs-left">Tiêu chuẩn khí thải</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['emissionDescription']}}</td>
                  </tr>

                  <tr>
                    <td>
                      <label>4.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin chung về kiểu loại xe</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.1. </td>
                    <td class="text-xs-left">Loại hình sản xuất, lắp ráp</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedAssemblyTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.2. </td>
                    <td class="text-xs-left">Loại phương tiện</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedVehicleTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3. </td>
                    <td class="text-xs-left">Nhãn hiệu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedTrademarkName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.4. </td>
                    <td class="text-xs-left">Tên thương mại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedCommercialName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">4.5. </td>
                    <td class="text-xs-left">Mã kiểu loại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['certifiedModelCode']}}</td>
                  </tr>


                  <tr>
                    <td>
                      <label>5.</label>
                    </td>
                    <td colspan="2">
                      <label>Thông tin xe mẫu, loại xe cở sở</label>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.1. </td>
                    <td class="text-xs-left">Số khung xe mẫu (số VIN)</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleVINNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.2. </td>
                    <td class="text-xs-left">Số động cơ xe mẫu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleEngineNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3. </td>
                    <td class="text-xs-left">Xe ô tô cơ sở (áp dụng cho xe đóng thùng)</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleVehicleTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.1 </td>
                    <td class="text-xs-left">Số GCN xe cơ sở</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['referenceCertificateNo']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.2 </td>
                    <td class="text-xs-left">Loại xe ô tô cơ sở</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleVehicleTypeDescription']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.3 </td>
                    <td class="text-xs-left">Nhãn hiệu</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleTrademarkName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.4 </td>
                    <td class="text-xs-left">Tên thương mại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleCommercialName']}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">5.3.5 </td>
                    <td class="text-xs-left">Mã kiểu loại</td>
                    <td class="text-xs-center">{{thongTinChungTSKT['sampleModelCode']}}</td>
                  </tr>
                </tbody>
              </table>

            </v-flex>
          </v-layout>
        </template>

        <v-flex xs12 sm12>
          <label>2. THÔNG SỐ KỸ THUẬT SẢN PHẨM</label>
        </v-flex>
        <v-flex xs12 sm12>
          <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
            <thead>
              <tr>
                <th class="text-xs-center">TT</th>
                <th class="text-xs-center">Hạng mục kiểm tra</th>
                <th class="text-xs-center">Kết quả kiểm tra</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in listThongSoKyThuat">
                <tr :key="'listThongSoKyThuat' + index">
                  <td colspan="3" style="text-align: left!important;">
                    <label>{{item['title']}}</label>
                  </td>
                </tr>
                <tr v-for="(itemTSKT, indexTSKT) in item['items']" :key="'listThongSoKyThuat_item' + indexTSKT">
                  <td class="text-xs-center">
                    {{indexTSKT + 1}}
                  </td>
                  <td>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-html="itemTSKT['title']"></span>
                  </td>
                  <td class="text-xs-center">
                      {{itemTSKT['value']}}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-flex>

        <v-flex xs12 sm12>
          <label>3. GHI CHÚ</label>
        </v-flex>
        <v-flex xs12 sm12>
          <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
            <tbody>
              <tr>
                <td class="text-xs-left">
                  <span>3.1</span>
                </td>
                <td class="text-xs-left">
                  <span>Ghi chú để in chứng chỉ</span>
                </td>
                <td class="text-xs-left">
                  <span>{{thongTinChungTSKT['certificateNote']}}</span>
                </td>
              </tr>
              <!-- <tr>
                <td class="text-xs-left">
                  <span>3.2</span>
                </td>
                <td class="text-xs-left">
                  <span>Ghi chú khác</span>
                </td>
                <td class="text-xs-left">
                  <span>{{thongTinChungTSKT['inspectionNote']}}</span>
                </td>
              </tr> -->
            </tbody>
          </table>
        </v-flex>

        <!-- <v-flex xs12 sm12>
          <label>4. HẠN XÁC NHẬN HIỆU LỰC</label>
        </v-flex>
        <v-flex xs12 sm12>
          <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
            <tr>
              <th style="text-align: center;border: 0.5px solid;">TT</th>
              <th style="text-align: center;border: 0.5px solid;">Số hồ sơ</th>
              <th style="text-align: center;border: 0.5px solid;">Ngày hiệu lực</th>
            </tr>
            <tr v-for="(item, index) in dsHSXNHL" :key="'dshsxnhl' + index">
              <td style=" text-align: center;border: 0.5px solid;">
                {{index + 1}}
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <span v-if="item['validdossierid'] == -1">{{item['dossierno']}}</span>
                <span v-else>{{item['validdossierno']}}</span>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                {{item['certificaterecordexpiredate']}}
              </td>
            </tr>
          </table>
        </v-flex>

        <v-flex xs12 sm12 v-if="showTongThanhTSKT">
          <label>5. DANH MỤC TỔNG THÀNH HỆ THỐNG</label>
        </v-flex>
        <v-flex xs12 sm12 v-if="showTongThanhTSKT">
          <label>Danh mục tổng thành phải kiểm tra chứng nhận</label>
          <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
            <thead>
              <tr>
                <th class="text-xs-center">TT</th>
                <th class="text-xs-center">Tổng thành, hệ thống</th>
                <th class="text-xs-center">Số GCN</th>
                <th class="text-xs-center">Nhãn hiệu, số loại/ mã hiệu</th>
                <th class="text-xs-center">Nguồn gốc</th>
                <th class="text-xs-center">Nước sản xuất</th>
              </tr>
            </thead>
            <tr v-for="(item, index) in vr_VehicleEquipment_BatBuoc" :key="'tongthanhhethongbatbuoc' + index">
              <td style=" text-align: center;border: 0.5px solid;">
                {{index + 1}}
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <span>{{item['certifiedVehicleTypeDescription']}}</span>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <span>{{item['certificateRecordNo']}}</span> <br>
                <span>{{parseTimeStampToDate(item['certificateRecordDate'])}}</span>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <span>{{item['certifiedTrademarkName']}}</span>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <span>{{item['originalName']}}</span>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                {{item['productionCountry']}}
              </td>
            </tr>
          </table>

          <label>Danh mục tổng thành không phải kiểm tra chứng nhận</label>
          <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
            <thead>
              <tr>
                <th class="text-xs-center">TT</th>
                <th class="text-xs-center">Tổng thành, hệ thống</th>
                <th class="text-xs-center">Số BCTN</th>
                <th class="text-xs-center">Nhãn hiệu, số loại/ mã hiệu</th>
                <th class="text-xs-center">Nguồn gốc</th>
                <th class="text-xs-center">Nơi sản xuất</th>
                <th class="text-xs-center">Nước sản xuất</th>
              </tr>
            </thead>
            <tr v-for="(item, index) in vr_VehicleEquipment_KoBatBuoc" :key="'tongthanhhethongkobatbuoc' + index">
              <td style=" text-align: center;border: 0.5px solid;">
                {{index + 1}}
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <span>{{item['certifiedVehicleTypeDescription']}}</span>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <span>{{item['safetytestReportNo']}}</span> <br>
                <span>{{parseTimeStampToDate(item['safetytestReportDate'])}}</span>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <span>{{item['certifiedTrademarkName']}}</span>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <span>{{item['originalName']}}</span>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                <template v-if="item['originalName'] == 3">
                  <div>
                    <span>{{item['manufacturerName']}}</span> <br>
                    <span>{{item['manufacturerAddress']}}</span>
                  </div>
                </template>
                <template v-else>
                  <div>
                    <span>{{item['productionName']}}</span> <br>
                    <span>{{item['productionAddress']}}</span>
                  </div>
                </template>
              </td>
              <td style=" text-align: center;border: 0.5px solid;">
                {{item['productionCountry']}}
              </td>
            </tr>
          </table>
        </v-flex> -->
      </v-layout>
    </v-expansion-panel>

  </div>

  <div v-else-if="detailPage == 3" style="width: 100%; background: #fff;">
    <div class="row-header">
      <div class="background-triangle-big"> KẾT QUẢ </div>
      <div class="layout row wrap header_tools row-blue">

        <div class="flex xs7 sm9 solo pl-4 pt-2 text-ellipsis">

          THÔNG SỐ KỸ THUẬT PHƯƠNG TIỆN

        </div>
        <div class="flex xs5 sm3 text-right" style="margin-left: auto;">

          <v-btn flat class=" my-0 py-0 btn-border-left" color="grey darken-1" v-on:click.native.prevent.stop="undoDetailPageTSKT()">
            <v-icon class="mr-2">undo</v-icon>
            Quay lại
          </v-btn>
        </div>

      </div>

    </div>

    <v-expansion-panel expand class="my-0 opencps-dossier-info">
      <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">
        <v-flex xs12 sm3>
          <span>Số giấy chứng nhận</span>: <label>{{thongTinChungTSKTPT['certificateRecordNo']}}</label>
        </v-flex>
        <v-flex xs12 sm3>
          <span>Ngày cấp</span>: <label>{{parseTimeStampToDate(thongTinChungTSKTPT['certificateRecordDate'])}}</label>
        </v-flex>
        <v-flex xs12 sm6>

        </v-flex>

        </v-flex>
        <v-flex xs12 sm3>
          <span>Số seri</span>: <label>{{thongTinChungTSKTPT['serialNo']}}</label>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">
        <v-flex xs12 sm12>
          <label>1. THÔNG TIN CHUNG</label>
        </v-flex>
        <v-flex xs12 sm12>
          <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
            <thead>
              <tr>
                <th class="text-xs-center">TT</th>
                <th class="text-xs-center">Hạng mục</th>
                <th class="text-xs-center">Nội dung</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <label>1.</label>
                </td>
                <td colspan="2">
                  <label>Thông tin về cơ sở sản xuất</label>
                </td>
              </tr>
              <tr>
                <td class="text-xs-left">1.1. </td>
                <td class="text-xs-left">Cơ sở sản xuất, lắp ráp</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['applicantName']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">1.1.1 </td>
                <td class="text-xs-left">Địa chỉ</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['applicantAddress']}}</td>
              </tr>
              <tr>
                <td>
                  <label>2.</label>
                </td>
                <td colspan="2">
                  <label>Thông tin chung về kiểu loại xe</label>
                </td>
              </tr>
              <tr>
                <td class="text-xs-left">2.1. </td>
                <td class="text-xs-left">Loại phương tiện</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedVehicleTypeDescription']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">2.2. </td>
                <td class="text-xs-left">Nhãn hiệu</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedTrademarkName']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">2.3. </td>
                <td class="text-xs-left">Tên thương mại</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedCommercialName']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">2.4. </td>
                <td class="text-xs-left">Mã kiểu loại</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedModelCode']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">2.5. </td>
                <td class="text-xs-left">Loại hình sản xuất, lắp ráp</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedAssemblyTypeDescription']}}</td>
              </tr>

              <tr>
                <td class="text-xs-left">2.6. </td>
                <td class="text-xs-left">Mã số VIN</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedVINNo']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">2.6.1 </td>
                <td class="text-xs-left">Mô tả vị trí đóng</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedVINPosition']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">2.7. </td>
                <td class="text-xs-left">Mã số khung</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedFrameNo']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">2.7.1. </td>
                <td class="text-xs-left">Nơi đóng số khung</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedFrameAttachPlace']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">2.8. </td>
                <td class="text-xs-left">Mã số động cơ</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedEngineNo']}}</td>
              </tr>
              <tr>
                <td class="text-xs-left">2.8.1. </td>
                <td class="text-xs-left">Nơi đóng số động cơ</td>
                <td class="text-xs-center">{{thongTinChungTSKTPT['certifiedEngineAttachPlace']}}</td>
              </tr>

            </tbody>
          </table>

        </v-flex>
      </v-layout>
      <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px;">
        <v-flex xs12 sm12>
          <label>2. THÔNG SỐ KỸ THUẬT</label>
        </v-flex>
        <v-flex xs12 sm12>
          <table class="table-basic px-4 pb-2 table-tskt" style="width:100%;">
            <thead>
              <tr>
                <th class="text-xs-center">TT</th>
                <th class="text-xs-center">Thông số kỹ thuật</th>
                <th class="text-xs-center">Giá trị</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in listThongSoKyThuatPT">
                <tr :key="'listThongSoKyThuatPT' + index">
                  <td colspan="3" style="text-align: left!important;">
                    <label>{{item['title']}}</label>
                  </td>
                </tr>
                <tr v-for="(itemTSKT, indexTSKT) in item['items']" :key="'listThongSoKyThuatPT_item' + indexTSKT">
                  <td class="text-xs-center">
                    {{indexTSKT + 1}}
                  </td>
                  <td>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-html="itemTSKT['title']"></span>
                  </td>
                  <td class="text-xs-center">
                      {{itemTSKT['value']}}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-flex>
      </v-layout>
    </v-expansion-panel>

  </div>

  <div v-else-if="detailPage == 4" style="width: 100%; background: #fff;">

    <div class="row-header">
      <div class="background-triangle-big"> KẾT QUẢ </div>
      <div class="layout row wrap header_tools row-blue">

        <div class="flex xs7 sm9 solo pl-4 pt-2 text-ellipsis" v-if="typeViewList == 1">

          ẢNH SẢN PHẨM

        </div>
        <div class="flex xs7 sm9 solo pl-4 pt-2 text-ellipsis" v-if="typeViewList == 2">

          BẢN VẼ

        </div>
        <div class="flex xs5 sm3 text-right" style="margin-left: auto;">

          <v-btn flat class=" my-0 py-0 btn-border-left" color="grey darken-1" v-on:click.native.prevent.stop="undoDetailPageTSKT()">
            <v-icon class="mr-2">undo</v-icon>
            Quay lại
          </v-btn>
        </div>

      </div>

    </div>

    <v-expansion-panel expand class="my-0 opencps-dossier-info">
      <v-layout row wrap class="ml-0 pl-0" style="padding-right: 15px; margin-top: 15px; height: 100vh !important; overflow: auto;">
        <v-flex xs12 sm3>
          <v-list>
            <div style="padding-left: 5px; font-weight: bold;" v-if="typeViewList == 1">
              Danh sách ảnh sản phẩm
            </div>
            <div style="padding-left: 5px; font-weight: bold;" v-if="typeViewList == 2">
              Danh sách bản vẽ
            </div>
            <v-list-tile v-for="(item, index) in listAnh" v-bind:key="item['id'] + 'anh'" @click="viewAnh(item, index)">
              <v-list-tile-content>
                <v-list-tile-title style="padding-left: 20px;"><b>{{index + 1}}. </b>{{item['displayName'] || ''}} <span style="font-style: italic; color: #14bef0; margin-left: 5px;">({{item['modifiedDate']}})</span>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex xs12 sm9>
          <div id="anhPdf" style="height: 100%;">
          </div>
          <div id="notFound" class="text-center"></div>
        </v-flex>
      </v-layout>
    </v-expansion-panel>

  </div>
</template>

<script>
/* eslint-disable */
import supportData from "../store/support_data.json";
import configJSON from "../store/config.json";
import fakeJSON from "../store/fakeResponse.json";
// import FilterAdv from './dklr/hanghai_filter_adv.vue'
// import TinyPagination from './dklr/hanghai_pagination.vue'
// import DateTimePicker from './dklr/DateTimePicker.vue'
import axios from "axios";
import $ from "jquery";
import toastr from "toastr";
toastr.options = {
  closeButton: true,
  timeOut: "3000",
};
export default {
  props: ["tab2"],
  components: {
    // 'tiny-pagination': TinyPagination,
    // 'jx-hanghai-filter-adv': FilterAdv,
    // 'DateTimePicker': DateTimePicker
  },
  computed: {},
  data: () => ({
    certificateSelected: '',
    listThongSoKyThuat: [],
    listThongSoKyThuatPT: [],
    showTongThanhTSKT: false,
    listServiceLinhKien: ['TT302011BGTVTCNCLKLLKOTO', 'TT302011BGTVTCNCLKLLKXCGXNHL', 'TT302011BGTVTCNCLKLLKXM', 'TT302011BGTVTCNCLKLLKXMXNHL'],
    listServiceSPM: ['TT302011BGTVTKTSPMXBBCN', 'TT302011BGTVTKTSPMXCG'],
    listServiceToanXe: ['TT302011BGTVTCNCLKLTXXBBCH', 'TT302011BGTVTCNCLKLTXXBBCHXNHL', 'TT302011BGTVTCNCLKLTXXBBCN', 'TT302011BGTVTCNCLKLTXXBBCNXNHL', 'TT302011BGTVTCNCLKLTXXCG', 'TT302011BGTVTCNCLKLTXXCGXNHL', 'TT302011BGTVTCNCLKLTXXDD', 'TT302011BGTVTCNCLKLTXXDDXNHL', 'TT302011BGTVTCNCLKLTXXMTGM', 'TT302011BGTVTCNCLKLTXXMTGMXNHL'],
    dsHSXNHL: [],
    thongTinChungTSKT: {},
    thongTinChungTSKTPT: {},
    vr_VehicleEquipment_BatBuoc: [],
    vr_VehicleEquipment_KoBatBuoc: [],
    menuDateTraCuuFrom: false,
    date: "",
    menuDateTraCuuTo: false,
    dialogTSKT: false,
    loadingDialog: false,
    headersTraCuu: [],
    listsTraCuu: [],
    fileTemplateNo: "",
    dossierId: 0,
    dossierFileId: 0,
    modules: configJSON["modules"],
    objectPT: configJSON["objectPT"], 
    loadingTableTraCuu: false,
    totalTraCuu: 0,
    lengthPageTraCuuThongKe: 0,
    pageTraCuuThongKe: 1,
    sourceTable: "",
    module: {},
    stageFilterView: null,
    detailPage: 1,
    typeViewList: 0,
    tenModuleTSKT: '',
    listAnh: [],
    typeAnh: 0,
    selectModule: {
      name: "Thẩm định thiết kế Xe cơ giới",
      children: [],
      level: 1,
      id: "TT302011BGTVTTDTKXCG",
      showLableSearch: false,
      doanhNghiep: null,
      listDoanhNghiep: [],
      module: "TT302011BGTVTTDTKXCG",
      pathParent: "Thẩm định thiết kế Xe cơ giới",
    },
    selectObjectPT: {
      "name": "Xe cơ giới",
      "children": [],
      "level": 1,
      "id": "XCG",
      "showLableSearch": false,
      "doanhNghiep": null,
      "listDoanhNghiep": [],
      "module": "XCG",
      "pathParent": "Xe cơ giới"
    },
    listSearch: [
      {
        index: 0,
        value: "",
        searchType: "",
        dataitem: "",
        dataCollection: [],
        conditionsSelect: {}
      }
    ],
    chooseTypeTraCuu: 'tt',
    pageSize: 15,
    page: 1,
    isToggle: true,
    conditions: [],
    dataItem: supportData["dataItem"],
    dataItemString: supportData["dataItemString"],
    dataItemKeyword: supportData["dataItemKeyword"],
    supportData: supportData,
    headers: [],
    lists: [],
    rules: {
      required: (value) => !!value || "Trường yêu cầu bắt buộc.",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+ "))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Email không hợp lệ.";
      },
    },
  }),
  beforeCreate() {
    var vm = this;
    vm.$nextTick(function () {});
  },
  created() {
    var vm = this;
    vm.$nextTick(function () {
      console.log("configJSON.module============", configJSON["module"]);
      let tab2 = this.tab2 || window.localStorage.getItem('tab2');
      console.log('this.tab2==============', tab2)
      let query = vm.$router.history.current.query;
      if (query && query["page"]) {
        vm.page = parseInt(query["page"]) || 1;
      } else {
        vm.page = 1;
      }
      vm.listsTraCuu = fakeJSON["fake"];
      vm.selectModuleAction();
      // this.getHeader(this.codeTable)
      // this.search()
    });
  },
  watch: {
    $route: function (newRoute, oldRoute) {
      // let vm = this
      // let query = newRoute.query
      let query = newRoute.query;
      if (query && query["page"]) {
        this.page = parseInt(query["page"]) || 1;
      } else {
        this.page = 1;
      }
      // this.getHeader(this.codeTable)
      // this.search()
    },
  },
  methods: {
    checkSearch() {
      let vm = this;
      if (vm.listSearch && vm.listSearch["length"]) {
        for (var i = 0; i < vm.listSearch.length; i++) {
          let item = vm.listSearch[i];
          if (
            item &&
            item["conditionsSelect"] &&
            item["conditionsSelect"]["value"]
          ) {
            return true;
          }
        }
      }
      return false;
    },
    controlLimit: function (id_, response) {
      $("." + id_ + "Class").show("fast");
      $.each(response, function (k, v) {
        if (k == "TechSpecs") {
          $.each(v, function (key, ob) {
            $("#" + ob).val("");
            $("#div-" + ob).addClass(id_ + "Class");
            $("#div-" + ob).hide("fast");
          });
        }
      });
    },
    getDataLimit: function (id_, vehicletype, formulatype, callback) {
      let vm = this;
      $.ajax({
        headers: {
          module: "1",
          dossierId: "",
          dossierFileId: vm.dossierFileId,
          groupId: 55301,
        },
        data: "",
        type: "get",
        dataType: "json",
        url:
          "/o/rest/vr-app/techspecslimit/vehicleclass/XCG/vehicletype/" +
          vehicletype +
          "/formulatype/" +
          formulatype,
        success: function (response) {
          callback(response);
        },
      });
    },
    parseDate2(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateTraCuuFrom(item) {
      let vm = this;
      item["fromDate"] = vm.parseDate2(item["fromDateTraCuu"]);
    },
    parseDateTraCuuTo(item) {
      let vm = this;
      item["toDate"] = vm.parseDate2(item["toDateTraCuu"]);
    },
    clickTypeTraCuu() {
      let vm = this;
      console.log(vm.chooseTypeTraCuu);
      if (vm.chooseTypeTraCuu == 'tt') {
        vm.selectObjectPTAction();
        vm.selectObjectPT = 'XCG';
      } else if (vm.chooseTypeTraCuu == 'dt') {
        vm.selectModuleAction();
        vm.selectModule = 'TT302011BGTVTTDTKXCG';
      }
    },
    selectModuleAction() {
      let vm = this;
      console.log("selectModule+++++", vm.selectModule);
      vm.listsTraCuu = [];
      vm.lengthPageTraCuuThongKe = 0;
      vm.pageTraCuuThongKe = 1;
      vm.listSearch = [
        {
          index: 0,
          value: null,
          searchType: null,
          dataitem: null,
          dataCollection: [],
          conditionsSelect: {},
          typeSearchItems: [],
        },
      ];
      if (vm.selectModule && vm.selectModule['module'] === 'COP') {
        vm.headersTraCuu = configJSON.headersCOP
        vm.conditions = configJSON.conditionsCOP
        vm.soureTable = 'vr_COPReportRepository'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT192012TTBGTVTDGLD') {
        vm.headersTraCuu = configJSON.headersBHBD
        vm.conditions = configJSON.conditionsCSBHBD
        vm.soureTable = 'vr_COPReportRepository'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLXMCD') {
        vm.headersTraCuu = configJSON.headersCNCLKL
        vm.conditions = configJSON.conditionsCNCLKLXMCD
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTTDTKXCG') {
        vm.headersTraCuu = configJSON.headersThamDinh
        vm.conditions = configJSON.conditionsTDTKXCG
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTTDTKXMCD') {
        vm.headersTraCuu = configJSON.headersThamDinh
        vm.conditions = configJSON.conditionsTDTKXMCD
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTKTSPMXCG') {
        vm.headersTraCuu = configJSON.headersKiemTraSanPhamMau
        vm.conditions = configJSON.conditionsKTSPMXCG
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTKTSPMXCNBB') {
        vm.headersTraCuu = configJSON.headersKiemTraSanPhamMau
        vm.conditions = configJSON.conditionsKTSPMXCNBB
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXCG') {
        vm.headersTraCuu = configJSON.headersCNCLKL
        vm.conditions = configJSON.conditionsCNCLKLXCG
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXMTGM') {
        vm.headersTraCuu = configJSON.headersCNCLKL
        vm.conditions = configJSON.conditionsCNCLKLXMY
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLLKOTO') {
        vm.headersTraCuu = configJSON.headersCNCLKL
        vm.conditions = configJSON.conditionsCNCLKLLKXCG
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLLKXM') {
        vm.headersTraCuu = configJSON.headersCNCLKL
        vm.conditions = configJSON.conditionsCNCLKLLKXMY
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXBBCN') {
        vm.headersTraCuu = configJSON.headersCNCLKL
        vm.conditions = configJSON.conditionsCNCLKLXCN
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXBBCH') {
        vm.headersTraCuu = configJSON.headersCNCLKL
        vm.conditions = configJSON.conditionsCNCLKLXCH
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXDD') {
        vm.headersTraCuu = configJSON.headersCNCLKL
        vm.conditions = configJSON.conditionsCNCLKLXDD
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && (vm.selectModule['module'] === 'TT302011BGTVTKTSPMXBBCN' || vm.selectModule['module'] === 'TT302011BGTVTKTSPMXCG')) {
        vm.headersTraCuu = configJSON.headersThamDinh
        vm.conditions = configJSON.conditionsKTSPMXCG
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCPPXCG') {
        vm.headersTraCuu = configJSON.headersCapPhoiPhieu
        vm.conditions = configJSON.conditionsCPP
        vm.soureTable = 'vr_Issue'
      } else if (vm.selectModule && vm.selectModule['module'] === '432014TTLTBGTVTBCTTTNLSXLR') {
        vm.headersTraCuu = configJSON.headersMTTNL
        vm.conditions = configJSON.conditionsMTTNLSXLR
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else if (vm.selectModule && vm.selectModule['module'] === '432014TTLTBGTVTBCTTTNLNK') {
        vm.headersTraCuu = configJSON.headersMTTNL
        vm.conditions = configJSON.conditionsMTTNLNK
        vm.soureTable = 'vr_VehicleTypeCertificate'
      } else {
        vm.headersTraCuu = configJSON.headersThamDinh
        vm.conditions = configJSON.conditionsTDTKXCG
        vm.soureTable = 'vr_VehicleTypeCertificate'
      }
      if (vm.selectModule["vehicleClass"] && vm.selectModule["table"]) {
        vm.getTSKT(vm.selectModule["vehicleClass"], vm.selectModule["table"]);
      }
      console.log("vm.conditions===============", vm.conditions);
    },
    selectObjectPTAction() {
      let vm = this;
      console.log("selectObjectPT+++++", vm.selectObjectPT);
      vm.listsTraCuu = [];
      vm.lengthPageTraCuuThongKe = 0;
      vm.pageTraCuuThongKe = 1;
      vm.listSearch = [
        {
          index: 0,
          value: null,
          searchType: null,
          dataitem: null,
          dataCollection: [],
          conditionsSelect: {},
          typeSearchItems: [],
        },
      ];
      vm.headersTraCuu = configJSON.headersPT
      vm.conditions = configJSON.conditionsPT
      vm.soureTable = 'vr_VehicleRecord'
      // if (vm.selectObjectPT["vehicleClass"] && vm.selectObjectPT["table"]) {
      //   vm.getTSKT(vm.selectObjectPT["vehicleClass"], vm.selectObjectPT["table"]);
      // }
      console.log("vm.conditions===============", vm.conditions);
    },
    checkMtCore(item) {
      let vm = this;
      let result = "";
      let ref = vm.soureTable + ".mtCore";
      let arrKey = ref.split(".");
      for (var i = 0; i < arrKey.length; i++) {
        let key = arrKey[i];
        if (typeof result === "object" && result.constructor === Object) {
          result = result[key];
        } else {
          result = item[key];
        }
      }
      if (result && (result === 1 || result === "1")) {
        return true;
      } else {
        return false;
      }
    },
    parseTimestamp(str) {
      if (!str) {
        return 0;
      }
      var dateString = str;
      var dateMomentObject = moment(dateString, "DD/MM/YYYY");
      var dateObject = dateMomentObject.toDate();
      return dateObject.getTime() || 0;
    },
    getCurrentTime() {
      let date = new Date();
      return (
        date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
      );
    },
    getSelect: function (item) {
      if (item['conditionsSelect'] && item['conditionsSelect']['url']) {
        $.ajax({
          url: item['conditionsSelect']['url'],
          headers: {
            groupId: 55301
          },
          dataType: 'json',
          success: function (result) {
            var data = result['data'] || result['Items']
            if (data && data['length']) {
              data = data.map(function (itemResponse) {
                return {
                  itemText: itemResponse[item['conditionsSelect']['itemText']] || itemResponse['value'],
                  itemValue: itemResponse[item['conditionsSelect']['itemValue']] || itemResponse['key']
                }
              })
            }
            if (item['conditionsSelect']) {
              item['conditionsSelect']['items'] = data || []
            }
          }
        })
      }
    },
    changeCondition(item) {
      var vm = this;
      var conditionsSelect = item["conditionsSelect"];
      item["valueSearch"] = "";
      console.log("conditionsSelect=============", conditionsSelect);
      if (conditionsSelect && conditionsSelect["type"]) {
        console.log(
          "conditionsSelect=======TYPE======",
          conditionsSelect["type"]
        );
        if (conditionsSelect["type"] === "string") {
          item["typeSearch"] = "like";
          item["typeSearchItems"] = this.dataItemString;
        } else if (conditionsSelect["type"] === "keyword") {
          item["typeSearch"] = "=";
          item["typeSearchItems"] = this.dataItemKeyword;
        } else if (conditionsSelect["type"] === "number") {
          item["typeSearch"] = "=";
          item["typeSearchItems"] = this.dataItem;
          item["valueSearch"] = 0;
        } else if (conditionsSelect["type"] === "select") {
          // item["typeSearch"] = "=";
          // item["typeSearchItems"] = this.dataItemString;
          item['typeSearch'] = '='
          item['typeSearchItems'] = this.dataItemString
          if (conditionsSelect['url']) {
            vm.getSelect(item)
          }
          item['valueSearch'] = ''
        } else {
          item["fromDate"] = this.getCurrentTime() || "";
          item["toDate"] = this.getCurrentTime() || "";
        }
      } else {
        item["typeSearch"] = "=";
      }
      console.log("item=============", item);
    },
    getTSKT(vehicleclass, table) {
      let vm = this;
      if (!vehicleclass) {
        return new Promise();
      }
      let url =
        "/o/rest/vr-app/techspecs/" + vehicleclass + "/vehicleclassexts";
      let urlTDTK =
        "/o/rest/vr-app/techspecs/" +
        "TDTK" +
        vehicleclass +
        "/vehicleclassexts";
      let configTSKT = {
        headers: {
          apikey: "1234567890",
          module: "",
          groupId: 55301,
        },
      };
      let tskt = axios.get(url, configTSKT);
      let tsktExts = axios.get(urlTDTK, configTSKT);
      Promise.all([tskt, tsktExts]).then((results) => {
        let resTSKT = results[0]["data"] || [];
        let resTSKT2 = results[1]["data"] || [];
        console.log("resTSKT============", resTSKT);
        console.log("resTSKT2============", resTSKT2);
        let resTmp = resTSKT.concat(resTSKT2);
        let res = [];
        for (var i = 0; i < resTmp.length; i++) {
          let items = resTmp[i]["items"] || [];
          for (var j = 0; j < items.length; j++) {
            if (items[j] && items[j]["datasource"]) {
              res.push({
                key: "data." + table + "." + items[j]["key"],
                value: items[j]["title"],
                type: "select",
                itemText: "text",
                itemValue: "value",
                items: items[j]["datasource"],
              });
            } else {
              res.push({
                key: "data." + table + "." + items[j]["key"],
                value: items[j]["title"],
                type: "string",
              });
            }
          }
        }
        console.log("res============", res);
        vm.conditions = vm.conditions.concat(res);
      });
    },
    removeSearch(item, index) {
      if (this.listSearch && this.listSearch["length"] === 1) {
        return;
      }
      this.listSearch.splice(index, 1);
    },
    getDisplay(item, link, type) {
      let result = "";
      if (!link) {
        return "";
      } else {
        let arrKey = link.split(".");
        for (var i = 0; i < arrKey.length; i++) {
          let key = arrKey[i];
          if (typeof result === "object" && result.constructor === Object) {
            result = result[key];
          } else {
            result = item[key];
          }
        }
      }
      if (type && type === "date" && result) {
        let date = new Date(result);
        let strDate =
          date.getDate() +
          "/" +
          (date.getMonth() + 1) +
          "/" +
          date.getFullYear();
        result = strDate;
      }
      console.log("link====================", link, result);
      return result;
    },
    getDisplay2(item, link1, link2) {
      let result = "";
      let result1 = "";
      let result2 = "";
      let arrKey1 = link1.split(".");
      let arrKey2 = link2.split(".");
      for (var i = 0; i < arrKey1.length; i++) {
        let key = arrKey1[i];
        if (typeof result1 === "object" && result1.constructor === Object) {
          result1 = result1[key];
        } else {
          result1 = item[key];
        }
      }
      for (var i = 0; i < arrKey2.length; i++) {
        let key = arrKey2[i];
        if (typeof result2 === "object" && result2.constructor === Object) {
          result2 = result2[key];
        } else {
          result2 = item[key];
        }
      }
      result = result1 + " " + result2;
      console.log("result1====================", result1);
      console.log("result2====================", result2);
      return result;
    },
    xemGiayChungNhan(item) {
      let vm = this;
      if (
        !item["vr_VehicleTypeCertificate"] ||
        !item["vr_VehicleTypeCertificate"]["deliverableFileEntryId"]
      ) {
        console.log(
          "not deliverableFileEntryId",
          item["vr_VehicleTypeCertificate"]["deliverableFileEntryId"]
        );
        return;
      }
      let url =
        "/o/rest/v2/dossiers/fileEntryId/" +
        item["vr_VehicleTypeCertificate"]["deliverableFileEntryId"];
      let configs = {
        headers: {},
        responseType: "blob",
      };
      axios
        .get(url, configs)
        .then(function (response) {
          var urlRes = window.URL.createObjectURL(response.data);
          window.open(urlRes, "_blank");
        })
        .catch(function (xhr) {
          console.log(xhr);
        });
    },
    // xemTSKT(item) {
    //   let vm = this;
    //   vm.dialogTSKT = true;
    //   vm.dossierId = item["dossierId"];
    //   vm.fileTemplateNo = item["vr_VehicleTypeCertificate"]
    //     ? item["vr_VehicleTypeCertificate"]["serviceCode"]
    //     : 0;
    //   vm.dossierFileId = item["vr_VehicleTypeCertificate"]
    //     ? item["vr_VehicleTypeCertificate"]["inspectionDossierFileId"]
    //     : 0;
    //   vm.getTrackChanges();
    //   vm.getSchema2(function (response) {
    //     var sum_res = response;
    //     vm.getSchema3(function (response2) {
    //       sum_res = $.merge(sum_res, response2);
    //       vm.generalHtml2(sum_res);
    //       $('.lv-one .lv-label:contains("II.5.4")').css("display", "none");
    //       var dong_co = $("#bb_loai_dong_co").val();
    //       if (dong_co == "") {
    //         $("#XCG01277").parent().parent().parent().parent().show();
    //         $("#XCG01300").parent().parent().parent().parent().show();
    //         $("#XCG01255").parent().parent().parent().parent().show();

    //         $("#XCG01277").parent().parent().parent().hide();
    //         $("#XCG01300").parent().parent().parent().hide();
    //         $("#XCG01255").parent().parent().parent().hide();

    //         $("#XCG01277")
    //           .parent()
    //           .parent()
    //           .parent()
    //           .parent()
    //           .find(".lv-title")
    //           .click(false);
    //         $("#XCG01300")
    //           .parent()
    //           .parent()
    //           .parent()
    //           .parent()
    //           .find(".lv-title")
    //           .click(false);
    //         $("#XCG01255")
    //           .parent()
    //           .parent()
    //           .parent()
    //           .parent()
    //           .find(".lv-title")
    //           .click(false);
    //       }
    //       if (dong_co == "hybrid") {
    //         $("#XCG01277")
    //           .parent()
    //           .parent()
    //           .parent()
    //           .find(".lv-title")
    //           .click(true);
    //         $("#XCG01277").parent().parent().parent().parent().show();
    //         $("#XCG01277").parent().parent().parent().show();
    //         $("#XCG01300").parent().parent().parent().parent().hide();
    //         $("#XCG01255").parent().parent().parent().parent().hide();
    //       }
    //       if (dong_co == "chay_dien") {
    //         $("#XCG01300")
    //           .parent()
    //           .parent()
    //           .parent()
    //           .find(".lv-title")
    //           .click(true);
    //         $("#XCG01300").parent().parent().parent().parent().show();
    //         $("#XCG01300").parent().parent().parent().show();
    //         $("#XCG01277").parent().parent().parent().parent().hide();
    //         $("#XCG01255").parent().parent().parent().parent().hide();
    //       }
    //       if (dong_co == "dot_trong") {
    //         $("#XCG01255")
    //           .parent()
    //           .parent()
    //           .parent()
    //           .find(".lv-title")
    //           .click(true);
    //         $("#XCG01255").parent().parent().parent().parent().show();
    //         $("#XCG01255").parent().parent().parent().show();
    //         $("#XCG01300").parent().parent().parent().parent().hide();
    //         $("#XCG01277").parent().parent().parent().parent().hide();
    //       }
    //     });
    //   });
    // },
    getDangKiemVien: function () {
      var vm = this
      return new Promise(function (resolve, reject) {
        if (vm.dangKiemVienItems && vm.dangKiemVienItems['length']) {
          resolve(vm.dangKiemVienItems);
          return;
        }
        $.ajax({
          url: '/o/rest/v2/employees/role/62111',
          dataType: "json",
          type: "GET",
          data: {
            'active': true
          },
          headers: {
            "groupId": "55301"
          },
          success: function (result) {
            vm.dangKiemVienItems = result['data'].map(function (item) {
              if (item['mappingUser'] && item['mappingUser']['userId']) {
                item['userId'] = item['mappingUser']['userId'] ? String(item['mappingUser']['userId']) : ''
              }
              return item
            }) || []
            console.log('vm.dangKiemVienItems========', vm.dangKiemVienItems)
            resolve(result);
          },
          error: function (result) {
            vm.dangKiemVienItems = []
            reject(result);
          }
        });
      })
    },
    parseTimeStampToDate: function (time) {
      if (!time) {
        return '';
      }
      if (typeof time == 'string') {
        return time;
      }
      var date = new Date(time);
      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
    },
    getDsHSXNHL: function (dossierIdCTN) {
      var vm = this;
      $.ajax({
        url : "/o/rest/vr-app/vrexpirecertificate",
        dataType : "json",
        type : "GET",
        headers : {"groupId": "55301"},
        data : {
          validDossierIdCTN: dossierIdCTN
        },
        success : function (result) {
          if (result && result['vr_expire_certificate'] && result['vr_expire_certificate']['length']) {
            var tmp = result['vr_expire_certificate'][0]
            $.ajax({
              url : "/o/rest/vr-app/vrexpirecertificate",
              dataType : "json",
              type : "GET",
              headers : {"groupId": "55301"},
              data : {
                dossierIdCTN: tmp['dossieridctn'] || tmp['dossierIdCTN']
              },
              success : function(resultCer){
                vm.dsHSXNHL= resultCer['vr_expire_certificate'] || []
              },
              error : function(xhr){
                vm.dsHSXNHL= []
                console.log(xhr)
              }
            });
          } else {
            $.ajax({
              url : "/o/rest/vr-app/vrexpirecertificate",
              dataType : "json",
              type : "GET",
              headers : {"groupId": "55301"},
              data : {
                dossierIdCTN: dossierIdCTN
              },
              success : function(resultCer){
                vm.dsHSXNHL= resultCer['vr_expire_certificate'] || []
              },
              error : function(xhr){
                vm.dsHSXNHL= []
                console.log(xhr)
              }
            });
          }
        },
        error : function(xhr){
          vm.dsHSXNHL= []
          console.log(xhr)
        }
      });
    },
    getEffectiveDate: function (dossierId) {
      var vm = this
      var effectiveDate = ''
      $.ajax({
        url: "/o/rest/v2/dossiers/" + dossierId,
        type: "GET",
        headers: {
          groupId: window.themeDisplay.getScopeGroupId()
        },
        dataType: 'json',
        async: false,
        success: function(response) {
          effectiveDate = response.createDate.split(" ")[0]
        }
      });
      return effectiveDate
    },
    xemTSKT: function (item) {
      var vm = this
      console.log('item TSKT', item);
      vm.detailPage = 2;
      vm.stageFilterView = 'thong_so_ky_thuat_popup'
      vm.thongTinChungTSKT = {};
      vm.thongTinChungTSKT = Object.assign({}, item['vr_VehicleTypeCertificate']);
      vm.vr_VehicleEquipment_BatBuoc = item['vr_VehicleEquipment'].filter(function (itemFt) {
        if (itemFt) {
          return itemFt['isMandatory'] == 1
        }
      })
      vm.vr_VehicleEquipment_KoBatBuoc = item['vr_VehicleEquipment'].filter(function (itemFt) {
        if (itemFt) {
          return itemFt['isMandatory'] != 1
        }
      })
      vm.dsHSXNHL = item['vr_Expire_Certificate'] || [];
      vm.listThongSoKyThuat = [];
      vm.showTongThanhTSKT = false;

      var dossierIdCTN = item['vr_VehicleTypeCertificate']['dossierIdCTN'] || 0;
      vm.getDsHSXNHL(dossierIdCTN);
      var vehicleClass = item['vr_VehicleTypeCertificate']['vehicleClass'] || '';
      var dossierId = item['dossierId'] || 0;
      var moduleVr = 1;
      var moduleVrVehicletypeCertificate = item['vr_VehicleTypeCertificate']['module'] || '';
      var serviceCode = item['vr_VehicleTypeCertificate']['serviceCode'] || '';
      var techspecsTmp = [];
      var certifiedVehicleType = item['vr_VehicleTypeCertificate']['certifiedVehicleType'] || '';

      if (serviceCode == 'TT302011BGTVTTDTKXCG') {
        techspecsTmp = item['vr_Technicalspec_XCG'];
        moduleVr = 1;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLLKOTO') {
        techspecsTmp = item['vr_Technicalspec_LKXCG'];
        moduleVr = 1;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLLKXCGXNHL') {
        techspecsTmp = [];
        moduleVr = 1;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLLKXM') {
        techspecsTmp = item['vr_Technicalspec_LKXMY'];
        moduleVr = 1;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLLKXMXNHL') {
        techspecsTmp = [];
        moduleVr = 1;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXBBCH') {
        techspecsTmp = item['vr_Technicalspec_XCHBB'];
        moduleVr = 21;
        vm.showTongThanhTSKT = true;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXBBCHXNHL') {
        techspecsTmp = [];
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXBBCN') {
        techspecsTmp = item['vr_Technicalspec_XCNBB'];
        vm.showTongThanhTSKT = true;
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXBBCNXNHL') {
        techspecsTmp = [];
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXCG') {
        techspecsTmp = item['vr_Technicalspec_XCG'];
        vm.showTongThanhTSKT = true;
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXCGXNHL') {
        techspecsTmp = [];
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXDD') {
        techspecsTmp = item['vr_Technicalspec_XDD'];
        vm.showTongThanhTSKT = true;
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXDDXNHL') {
        techspecsTmp = [];
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXMTGM') {
        techspecsTmp = item['vr_Technicalspec_XMY'];
        vm.showTongThanhTSKT = true;
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTCNCLKLTXXMTGMXNHL') {
        techspecsTmp = [];
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTKTSPMXBBCN') {
        techspecsTmp = item['vr_Technicalspec_XCNBB'];
        moduleVr = 21;
      } else if (serviceCode == 'TT302011BGTVTKTSPMXCG') {
        techspecsTmp = item['vr_Technicalspec_XCG'];
        moduleVr = 21;
      } else if (serviceCode == '432014TTLTBGTVTBCTTTNLNK') {
        techspecsTmp = item['vr_Technicalspec_XCG'];
      } else if (serviceCode == '432014TTLTBGTVTBCTTTNLSXLR') {
        techspecsTmp = item['vr_Technicalspec_XCG'];
      } else {
        techspecsTmp = item['vr_Technicalspec_XCG'];
        moduleVr = 1;
      }

      if (moduleVrVehicletypeCertificate == '01') {
        vm.tenModuleTSKT = 'THẨM ĐỊNH THIẾT KẾ';
      } else if (moduleVrVehicletypeCertificate == '02') {
        vm.tenModuleTSKT = 'KIỂM TRA SP MẪU';
      } else if (moduleVrVehicletypeCertificate == '03') {
        vm.tenModuleTSKT = 'CHỨNG NHẬN KIỂU LOẠI TOÀN XE';
      } else if (moduleVrVehicletypeCertificate == '04') {
        vm.tenModuleTSKT = 'CHỨNG NHẬN KIỂU LOẠI LINH KIỆN';
      } else if (moduleVrVehicletypeCertificate == '05') {
        vm.tenModuleTSKT = 'CHỨNG NHẬN MTTNL SXLR';
      } else if (moduleVrVehicletypeCertificate == '06') {
        vm.tenModuleTSKT = 'CHỨNG NHẬN MTTNL NK';
      } else {
        vm.tenModuleTSKT = '';
      }

      vm.getDangKiemVien().then(function (dkv) {
        var tmpDKV = vm.dangKiemVienItems.find(function (itemDKV) {
          return String(itemDKV['userId']) == String(vm.thongTinChungTSKT['inspectorId']);
        })
        if (tmpDKV) {
          vm.thongTinChungTSKT['inspectorName'] = tmpDKV['fullName'] || '';
        }
      })
      console.log('techspecsTmp==========', techspecsTmp);
      vm.thongTinChungTSKT['certificateRecordDate'] = vm.parseTimeStampToDate(vm.thongTinChungTSKT['certificateRecordDate']) || '';
      vm.thongTinChungTSKT['verificationCertificateDate'] = vm.parseTimeStampToDate(vm.thongTinChungTSKT['verificationCertificateDate']) || '';
      vm.thongTinChungTSKT['inspectionDate'] = vm.parseTimeStampToDate(vm.thongTinChungTSKT['inspectionDate']) || '';
      if (vehicleClass) {
        var url = '';
        var effectiveDate = '';
        if (vehicleClass == 'LKXCG' || vehicleClass == 'LKXMY' && certifiedVehicleType) {
          url = '/o/rest/vr-app/techspecs/' + vehicleClass + '/' + certifiedVehicleType + '/vehicleclassexts'
        } else {
          url = '/o/rest/vr-app/techspecs/' + vehicleClass + '/vehicleclassexts'
        }
        if (moduleVr == 21) {
          effectiveDate = vm.getEffectiveDate(dossierId)
          url += '?effectiveDate='
          url += effectiveDate
        }
        $.ajax({
          headers: {
            "apikey": '1234567890',
            "module": moduleVr,
            "dossierId": dossierId,
            "groupId": 55301,
            "flag": "bb"
          },
          data: "",
          type: 'GET',
          dataType: 'json',
          url: url,
          success: function(responseFull) {
            console.log(responseFull);
            var response = [];
            
            if (!vm.showTongThanhTSKT) {
              response = responseFull;
            } else {
              responseFull.forEach(function(tskt, index) {
                var tsktTemp = tskt;
                if (tskt['items'] && tskt['items']['length']) {
                  var items = [];
                  tskt['items'].forEach(function(itemTSKT, indexTSKT) {
                    if (itemTSKT['specificationGroup'] == 1) {
                      items.push(itemTSKT);
                    }
                  });
                  tsktTemp['items'] = items;
                }
                response.push(tsktTemp);
              });
            }

            console.log(response);
            if (response && response['length']) {
              response.forEach(function (tskt, index) {
                if (tskt['items'] && tskt['items']['length']) {
                  tskt['items'].forEach(function (itemTSKT, indexTSKT) {
                    if (techspecsTmp && techspecsTmp['length']) {
                      techspecsTmp.forEach(function (itemVal, indexVal) {
                        for (var key in itemVal) {
                          if (itemTSKT['key'] == key) {
                            itemTSKT['value'] = itemVal[key] || '';
                          }
                        }
                      });
                    }
                  });
                }
              });
              vm.listThongSoKyThuat = response.slice();
            } else {
              vm.listThongSoKyThuat = [];
            }
            console.log('listThongSoKyThuat==============', vm.listThongSoKyThuat);
          },
          error: function (xhr) {
            vm.listThongSoKyThuat = [];
          }
        })
      }
    },
    // checkPartNo (serviceCode) {
    //   if () {

    //   }
    // },
    getDossierFileAndView(item) {
      let vm = this;
      let param = {
        params: data,
        responseType: "blob",
      };
      let url =
        "/o/rest/v2/dossiers/" +
        vm.dossierId +
        "/files/" +
        item["referenceUid"];
      axios
        .get("", param)
        .then(function (response) {
          var url = window.URL.createObjectURL(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // getSelect(item, key) {
    //   if (item && item["items"]["length"]) {
    //     return item["items"];
    //   } else {
    //     return [];
    //   }
    // },
    pagingTraCuu(page) {
      let vm = this;
      console.log("vm.pageTraCuuThongKe==============", vm.pageTraCuuThongKe);
      vm.traCuuThongKeAction();
    },
    getHeader(code) {
      let vm = this;
      if (code === "COP") {
        vm.headers = supportData["headersCOP"];
        vm.conditions = supportData["conditionsCOP"];
        vm.sourceTable = "vr_COPReportRepository";
      } else {
        vm.headers = supportData["headersCNCLKL"];
        vm.conditions = supportData["conditionsCNCLKL"];
        vm.sourceTable = "vr_VehicleTypeCertificate";
      }
    },
    searchActionBtn() {
      this.page = 1;
      let path = this.$router.history.current.path;
      let query = this.$router.history.current.query;
      this.$router.push({
        path: path,
        query: {
          ...query,
          page: 1,
        },
      });
    },
    async search(query) {
      console.log(this.module);
      let vm = this;
      console.log("query================", vm.$router.history.current.query);
      let queryTmp = {};
      if (!query) {
        queryTmp = vm.$router.history.current.query;
        console.log("queryTmp================", queryTmp);
        delete queryTmp["page"];
      }
      let queries = vm.generateQuery(vm.pageTraCuuThongKe, queryTmp);
      this.$store.dispatch("getDataTable", queries).then((result) => {
        console.log("result ============>>", result);
        let tmpData = result["hits"]["hits"] || [];
        if (tmpData && tmpData["length"]) {
          if (vm.codeTable === "COP") {
            tmpData = vm.convertModelCOP(tmpData);
          } else {
            tmpData = vm.convertModelCNCLKL(tmpData);
          }
        }
        console.log("tempData==============", tmpData);
        vm.lists = tmpData;
        vm.totalTraCuu = result["hits"]["total"] || 0;
      });
    },
    convertModelCOP(model) {
      if (!model) {
        return [];
      }
      return model.map((item) => {
        return {
          vr_ProductionPlantEquipment: item['_source']['data']['vr_ProductionPlantEquipment'],
          vr_ProductType: item['_source']['data']['vr_ProductType'],
          vr_COPReportRepository: item['_source']['data']['vr_COPReportRepository'],
          vr_ProductionPlantEmployee: item['_source']['data']['vr_ProductionPlantEmployee'],
          vr_COPReport_attach: item['_source']['data']['vr_COPReport_attach'],
          vr_COPProductLine: item['_source']['data']['vr_COPProductLine'],
          vr_ProductionPlantProdEquipment: item['_source']['data']['vr_ProductionPlantProdEquipment'],
          dossierId: item['_source']['dossierId'],
          dossierIdCTN: item['_source']['dossierIdCTN'],
          dossierNo: item['_source']['dossierNo'],
          companyId: item['_source']['companyId'],
          id: item['_source']['id']
        };
      });
    },
    convertModelCNCLKL(model) {
      if (!model) {
        return [];
      }
      return model.map((item) => {
        return {
          vr_InspectionStandard: item['_source']['data']['vr_InspectionStandard'],
          vr_Technicalspec_LKXCG: item['_source']['data']['vr_Technicalspec_LKXCG'],
          vr_Technicalspec_LKXMY: item['_source']['data']['vr_Technicalspec_LKXMY'],
          vr_Technicalspec_XCG: item['_source']['data']['vr_Technicalspec_XCG'],
          vr_Technicalspec_XCHBB: item['_source']['data']['vr_Technicalspec_XCHBB'],
          vr_Technicalspec_XCNBB: item['_source']['data']['vr_Technicalspec_XCNBB'],
          vr_Technicalspec_XDD: item['_source']['data']['vr_Technicalspec_XDD'],
          vr_Technicalspec_XMY: item['_source']['data']['vr_Technicalspec_XMY'],
          vr_VehicleEquipment: item['_source']['data']['vr_VehicleEquipment'],
          vr_technicalspec_xmy: item['_source']['data']['vr_technicalspec_xmy'],
          vr_cfg_technicalspec: item['_source']['data']['vr_cfg_technicalspec'],
          vr_VehicleSpecification: item['_source']['data']['vr_VehicleSpecification'],
          vr_inspectionstandard: item['_source']['data']['vr_inspectionstandard'],
          vr_technicalspec_xcg: item['_source']['data']['vr_technicalspec_xcg'],
          vr_VehicleEquipment: item['_source']['data']['vr_VehicleEquipment'],
          vr_technicalspec_lkxmy: item['_source']['data']['vr_technicalspec_lkxmy'],
          vr_technicalspec_xdd: item['_source']['data']['vr_technicalspec_xdd'],
          vr_technicalspec_xcnbb: item['_source']['data']['vr_technicalspec_xcnbb'],
          vr_cfg_limit_technicalspec: item['_source']['data']['vr_cfg_limit_technicalspec'],
          vr_technicalspec_lkxcg: item['_source']['data']['vr_technicalspec_lkxcg'],
          vr_technicalspec_xchbb: item['_source']['data']['vr_technicalspec_xchbb'],
          vr_VehicleTypeCertificate: item['_source']['data']['vr_VehicleTypeCertificate'],
          dossierId: item['_source']['dossierId'],
          dossierIdCTN: item['_source']['dossierIdCTN'],
          dossierNo: item['_source']['dossierNo'],
          companyId: item['_source']['companyId'],
          id: item['_source']['id']
        };
      });
    },
    generateQuery(page, query) {
      let vm = this;
      let mustQuery = [];
      let queries = {};
      if (vm.chooseTypeTraCuu == 'tt') {
        mustQuery = [
          {
            match: {
              type_es: vm.soureTable,
            },
          },
        ];
        queries = {
          indice: vm.soureTable,
          query: {
            size: 20,
            from: this.pageTraCuuThongKe * 20 - 20,
            query: {
              bool: {
                must: mustQuery,
              },
            },
          },
        };
        for (var i = 0; i < vm.listSearch.length; i++) {
          if (vm.listSearch[i] && vm.listSearch[i]["conditionsSelect"]) {
            let conditionsSelect = vm.listSearch[i]["conditionsSelect"];
            var key = conditionsSelect['key']
            if (key && key.indexOf('data.') === -1) {
              key = "data." + key;
            }
            if (vm.listSearch[i]["conditionsSelect"]["type"] === "string") {
              if (conditionsSelect) {
                let tmpObj = {};
                tmpObj[key] = vm.listSearch[i]["valueSearch"];
                mustQuery.push({
                  match_phrase: tmpObj,
                });
              }
            } else if (
              vm.listSearch[i]["conditionsSelect"]["type"] === "keyword"
            ) {
              if (conditionsSelect) {
                let tmpObj = {
                  term: {},
                };
                // tmpObj['term'][key + '.keyword'] = vm.listSearch[i]['valueSearch']
                tmpObj["term"][key] = vm.listSearch[i]["valueSearch"];
                mustQuery.push(tmpObj);
              }
            } else if (vm.listSearch[i]["conditionsSelect"]["type"] === "date") {
              if (conditionsSelect) {
                let tmpObj = {};
                let fromDate = vm.parseTimestamp(vm.listSearch[i]["fromDate"]);
                let tmp = 86399000; // 23h59'59s cộng thêm để tìm chính xác tới cuối ngày
                let toDate = vm.parseTimestamp(vm.listSearch[i]["toDate"]) + tmp;
                tmpObj[key] = {
                  gte: fromDate,
                  lte: toDate,
                };
                mustQuery.push({
                  range: tmpObj,
                });
              }
            } else if (
              vm.listSearch[i]["conditionsSelect"]["type"] === "number"
            ) {
              console.log(
                "typeSearch+++++++++++++++++++",
                vm.listSearch[i]["typeSearch"]
              );
              if (conditionsSelect) {
                let tmpObj = {};
                tmpObj[key] = {};
                if (vm.listSearch[i]["typeSearch"] === "gte") {
                  tmpObj[key] = {
                    gte: parseFloat(vm.listSearch[i]["valueSearch"]),
                  };
                  mustQuery.push({
                    range: tmpObj,
                  });
                } else if (vm.listSearch[i]["typeSearch"] === "lte") {
                  tmpObj[key] = {
                    lte: parseFloat(vm.listSearch[i]["valueSearch"]),
                  };
                  mustQuery.push({
                    range: tmpObj,
                  });
                } else if (vm.listSearch[i]["typeSearch"] === "=") {
                  tmpObj[key] = {
                    lte: parseFloat(vm.listSearch[i]["valueSearch"]),
                    gte: parseFloat(vm.listSearch[i]["valueSearch"]),
                  };
                  mustQuery.push({
                    range: tmpObj,
                  });
                } else {
                  tmpObj[key] = {
                    lte: parseFloat(vm.listSearch[i]["valueSearch"]),
                    gte: parseFloat(vm.listSearch[i]["valueSearch"]),
                  };
                  mustQuery.push({
                    range: tmpObj,
                  });
                }
              }
            } else if (
              vm.listSearch[i]["conditionsSelect"]["type"] === "select"
            ) {
              if (conditionsSelect && vm.listSearch[i]["valueSearch"] !== "") {
                let tmpObj = {
                  term: {},
                };
                // tmpObj['term'][key + '.keyword'] = vm.listSearch[i]['valueSearch']
                tmpObj["term"][key] = vm.listSearch[i]["valueSearch"];
                mustQuery.push(tmpObj);
              }
            }
          }
        }
        let tmpObj = {
          term: {},
        };
        if (vm.selectModule["module"] !== "COP") {
          tmpObj["term"]["data.vr_VehicleTypeCertificate.serviceCode"] = vm.selectModule["module"] || "TT302011BGTVTTDTKXCG";
          mustQuery.push(tmpObj);
        }
        let tmpObj2 = {
          "bool": {
            "should": [{
              "term": {
                "data.vr_VehicleTypeCertificate.certificateRecordStatus": "2"
              }
            }, {
              "term": {
                "data.vr_VehicleTypeCertificate.certificateRecordStatus": "3"
              }
            }]
          }
        };
        if (vm.selectModule["module"] !== "COP") {
          mustQuery.push(tmpObj2);
        }

        queries = {
          indice: vm.soureTable,
          query: {
            size: 20,
            _source: vm.selectModule["sourceFilters"] || {
              excludes: ["data.vr_VehicleSpecification"],
            },
            from: this.pageTraCuuThongKe * 20 - 20,
            query: {
              bool: {
                must: mustQuery,
              },
            },
          },
        };
      } else if (vm.chooseTypeTraCuu == 'dt') {
        var data = {};
        queries = {
          headers: {
            'groupId': '55301'
          }
        }
        for (var i = 0; i < vm.listSearch.length; i++) {
          if (vm.listSearch[i] && vm.listSearch[i]['conditionsSelect']) {
            var conditionsSelect = vm.listSearch[i]['conditionsSelect']
            var key = conditionsSelect['key']
            if (key == "productionDate") {
              var fromDate = vm.listSearch[i]['fromDate']
              var toDate = vm.listSearch[i]['toDate']
              data['productionDateFrom'] = fromDate
              data['productionDateTo'] = toDate
            } else if (key == "certificateRecordDate") {
              var fromDate = vm.listSearch[i]['fromDate']
              var toDate = vm.listSearch[i]['toDate']
              data['certificateRecordDateFrom'] = fromDate
              data['certificateRecordDateTo'] = toDate
            } else {
              var value = vm.listSearch[i]['valueSearch'] ? String(vm.listSearch[i]['valueSearch']).trim() : ''
              data[key] = value
            }
          }
        }
        console.log('selectModulePT----', vm.selectObjectPT["id"])
        if (vm.selectObjectPT["id"] == "XCG") {
            data['vehicleClass'] = 'XCG'
        } else if (vm.selectObjectPT["id"] == "XMY") {
            data['vehicleClass'] = 'XMY'
        } else if (vm.selectObjectPT["id"] == "XDD") {
            data['vehicleClass'] = 'XDD'
        } else if (vm.selectObjectPT["id"] == "XCH") {
            data['vehicleClass'] = 'XCH'
        } else if (vm.selectObjectPT["id"] == "XCN") {
            data['vehicleClass'] = 'XCN'
        } else {
            data['vehicleClass'] = 'XCG'
        }
        data['start'] = page * 20 - 20;
        data['end'] = page * 20;
        queries['params'] = data;
      }
      console.log("query ========", queries);
      return queries;
    },
    traCuuThongKe: function (callBack) {
      var vm = this;
      console.log("load more!!");
      vm.pageTraCuuThongKe = 1;
      if (!vm.checkSearch()) {
        toastr.error("Vui lòng chọn một điều kiện tìm kiếm!");
        return;
      } else if (vm.chooseTypeTraCuu == 'dt'){
        console.log('vm.listSearch+++', vm.listSearch);
        for (var i = 0; i < vm.listSearch.length; i++) {
          let item = vm.listSearch[i];
          if (!item["valueSearch"]
          ) {
            toastr.error("Mời nhập dữ liệu tìm kiếm!");
            return;
          }
        }
      }
      vm.traCuuThongKeAction();
    },
    traCuuThongKeAction: function (callBack) {
      var vm = this;
      if (vm.chooseTypeTraCuu == 'tt') {
        let queries = vm.generateQuery(vm.pageTraCuuThongKe, {});
        vm.listsTraCuu = [];
        vm.loadingTableTraCuu = true;
        var promise = new Promise(function (resolve, reject) {
          var url = "/o/rest/vr-app/_search";
          axios.post(url, queries).then(function (response) {
            var serializable = response.data;
            if (typeof serializable['hits']['total'] === 'number') {
              vm.totalTraCuu = serializable['hits']['total'] || 0
              vm.lengthPageTraCuuThongKe = Math.ceil((serializable['hits']['total'] || 0) / 20);
            } else {
              vm.totalTraCuu = serializable['hits']['total'] ? serializable['hits']['total']['value'] : 0
              var totalTmp = serializable['hits']['total'] ? serializable['hits']['total']['value'] : 0
              vm.lengthPageTraCuuThongKe = Math.ceil(totalTmp / 20);
            }
            var tmpData = serializable['hits']['hits'] || []
            if (tmpData && tmpData['length']) {
              if (vm.selectModule && vm.selectModule['module'] === 'COP' || vm.selectModule['module'] === 'TT192012TTBGTVTDGLD') {
                tmpData = vm.convertModelCOP(tmpData);
              } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCPPXCG'
                || vm.selectModule['module'] === 'TT302011BGTVTCPPXMTGM'
                || vm.selectModule['module'] === 'TT302011BGTVTCPPXMTGM2'
                || vm.selectModule['module'] === 'TT302011BGTVTCPPXBBCN'
                || vm.selectModule['module'] === 'TT302011BGTVTCPPXBBCH'
                || vm.selectModule['module'] === 'TT302011BGTVTCPPXDD') {
                tmpData = vm.convertModelCPP(tmpData);
              } else {
                tmpData = vm.convertModelCNCLKL(tmpData);
              }
            }
            console.log('tmpData___', tmpData);
            vm.listsTraCuu = tmpData || [];
            vm.loadingTableTraCuu = false;
            resolve(true);
          })
          .catch(function (error) {
            console.log(error);
            setTimeout(function () {
              vm.loadingTableTraCuu = false;
            }, 2000);
            reject(false);
          });
        });
        promise.then(
          function (success) {},
          function (xhr) {}
        );
      } else if (vm.chooseTypeTraCuu == 'dt') {
        var queries = vm.generateQuery(vm.pageTraCuuThongKe, {})
        vm.listsTraCuu = []
        vm.loadingTableTraCuu = true
        vm.lengthPageTraCuuThongKe = 0
        var pagePT = vm.pageTraCuuThongKe;
        var promise = new Promise(function (resolve, reject) {
          var url = '/o/rest/vr-app/record/search/1';
          axios.get(url, queries).then(function (response) {
            var data = response.data;
            var tmpData = data.data;                
            console.log('tmpData___', tmpData);
            vm.listsTraCuu = tmpData || []
            vm.loadingTableTraCuu = false
            vm.totalTraCuu = data.total
            vm.lengthPageTraCuuThongKe = Math.ceil(data.total / 20);                
            //vm.pageTraCuuThongKePT = pagePT * 20;
            resolve(true);
          }).catch(function (error) {
            console.log(error);
            vm.loadingTableTraCuu = false
            reject(false);
          });
        });
        promise.then(function (success) {
          // callBack();
        }, function (error) {

        });
      }
    },
    xemThongTinPXX: function (item) {
      var vm = this;
      var url = '/o/rest/vr-app/issue/view/pxx';
      var urlfile = "";
      var fileEntry = 0;
      $.ajax({
        url: url,
        headers: {"groupId": "55301"},
        dataType: "json",
        type: "PUT",
        contentType: "application/x-www-form-urlencoded; charset=utf-8",
        async: false,
        data: {
          vehicleClass: item['vehicleClass'],
          vehicleRecordId: item['id']
        },
        success: function (success) {
          urlfile = success['fileURL'];   
          fileEntry = success['fileEntryId'];      
          if (fileEntry) {
            window.open(urlfile, '_blank');
          } else {
            vm.snackbartextdossierViewJX = "Không tìm thấy file!";
            vm.snackbarerordossierViewJX = true;
          }
        },
        error: function (xhr) {
          console.log(xhr);
        }
      });      
    },
    xemTSKT2: function (item) {
      var vm = this;
      var certificateId = item['certificateId'];
      var dossierId = '';
      var vehicleClass = '';
      var dossierFileId = '';
      var bang = '';
      var techspecsTmp = [];
      console.log('item TSKT', item);
      
      vm.detailPage = 3;
      vm.stageFilterView = 'thong_so_ky_thuat_popup';
      vm.listThongSoKyThuatPT = [];

      $.ajax({
        headers: {
          "groupId": 55301
        },
        data: {
          "certificateId": certificateId
        },
        type: 'get',
        async: false,
        dataType: 'json',
        url: '/o/rest/vr-app/certificate/vehicleClass',
        success: function(response) {
          var data = response.data[0];
          dossierId = data['dossierId'];
          vehicleClass = data['vehicleClass'];
          vm.thongTinChungTSKTPT = data;
          vm.thongTinChungTSKTPT['serialNo'] = item['serialNo'];
        }
      });

      if (vehicleClass == 'XCG') {
        bang = 'vr_Technicalspec_XCG';
      } else if (vehicleClass == 'XMY') {
        bang = 'vr_Technicalspec_XMY';
      } else if (vehicleClass == 'XDD') {
        bang = 'vr_Technicalspec_XDD';
      } else if (serviceCode == 'XCH') {
        bang = 'vr_Technicalspec_XCHBB';
      } else if (serviceCode == 'XCN') {
        bang = 'vr_Technicalspec_XCNBB';
      }

      $.ajax({
        headers: {
          "groupId": 55301
        },
        data: {},
        type: 'get',
        async: false,
        dataType: 'json',
        url: '/o/rest/vr-app/techspecs/' + dossierId + '?table=' + bang,
        success: function(response) {
          techspecsTmp.push(response);
        }
      });
      console.log('techspecsTmp==========', techspecsTmp);
      var effectiveDate = getEffectiveDate(dossierId)
      $.ajax({
        headers: {
          "apikey": '1234567890',
          "module": 21,
          "dossierId": dossierId,
          "dossierFileId": 0,
          "groupId": 55301,
          "flag": "bb"
        },
        data: "",
        type: 'GET',
        async: false,
        dataType: 'json',
        url: '/o/rest/vr-app/techspecs/' + vehicleClass + '/vehicleclassexts?effectiveDate=' + effectiveDate,
        success: function(responseFull) {
          console.log(responseFull);
          var response = [];
            
          if (!vm.showTongThanhTSKT) {
            response = responseFull;
          } else {
            responseFull.forEach(function(tskt, index) {
              var tsktTemp = tskt;
              if (tskt['items'] && tskt['items']['length']) {
                var items = [];
                tskt['items'].forEach(function(itemTSKT, indexTSKT) {
                  if (itemTSKT['specificationGroup'] == 1) {
                    items.push(itemTSKT);
                  }
                });
                tsktTemp['items'] = items;
              }
              response.push(tsktTemp);
            });
          }
            
          if (response && response['length']) {
            response.forEach(function(tskt, index) {
              if (tskt['items'] && tskt['items']['length']) {
                tskt['items'].forEach(function(itemTSKT, indexTSKT) {
                  if (techspecsTmp && techspecsTmp['length']) {
                    techspecsTmp.forEach(function(itemVal, indexVal) {
                      for (var key in itemVal) {
                        if (itemTSKT['key'] == key) {
                          itemTSKT['value'] = itemVal[key] || '';
                        }
                      }
                    });
                  }
                });
              }
            });
            vm.listThongSoKyThuatPT = response.slice();
          } else {
            vm.listThongSoKyThuatPT = [];
          }
          console.log('listThongSoKyThuatPT==============', vm.listThongSoKyThuatPT);
        },
        error: function(xhr) {
          vm.listThongSoKyThuatPT = [];
        }
      });
    },
    viewListAnh: function (item, type) {
      var vm = this;
      vm.certificateSelected = type;
      vm.typeViewList = 1;
      var dossierId = item['dossierId'];
      var dossierIdGCN = item['dossierIdGCN'];
      var targetDossierId = (type == 2) ? dossierIdGCN : dossierId;
      var certificate = '';
      if (type == 1) {
        certificate = item['vr_VehicleTypeCertificate']['certificateRecordNo'];
      } else if (type == 2) {
        certificate = item['certificateRecordNo'];
      }
      var certificaterecordno = certificate.replace(/[^A-Z0-9]/g, "");
      vm.listAnh = [];
      $.ajax({
        url: "/o/rest/v2/dossiers/" + targetDossierId + "/files",
        type: "GET",
        headers: {
          groupId: window.themeDisplay.getScopeGroupId()
        },
        dataType: 'json',
        async: false,
        success: function(result) {
          var moduleSelected
          if (result && result.data && result.data.length) {
            moduleSelected = result.data[0]['dossierTemplateNo']
          }
          var dossierPart = '';
          if (type != 2) {
            if (vm.selectModule && vm.selectModule['module'] === 'COP') {
              dossierPart = '';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT192012TTBGTVTDGLD') {
              dossierPart = '';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLXMCD') {
              dossierPart = '';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTTDTKXCG') {
              dossierPart = '';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTTDTKXMCD') {
              dossierPart = '';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTKTSPMXCG') {
              dossierPart = 'TP2';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTKTSPMXCNBB') {
              dossierPart = 'TP2';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXCG') {
              dossierPart = 'TP4';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXMTGM') {
              dossierPart = 'TP4';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLLKOTO') {
              dossierPart = 'TP2';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLLKXM') {
              dossierPart = 'TP2';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXBBCN') {
              dossierPart = 'TP4';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXBBCH') {
              dossierPart = 'TP4';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCNCLKLTXXDD') {
              dossierPart = 'TP4';
            } else if (vm.selectModule && (vm.selectModule['module'] === 'TT302011BGTVTKTSPMXBBCN' || vm.selectModule['module'] === 'TT302011BGTVTKTSPMXCG')) {
              dossierPart = 'TP2';
            } else if (vm.selectModule && vm.selectModule['module'] === 'TT302011BGTVTCPPXCG') {
              dossierPart = '';
            } else if (vm.selectModule && vm.selectModule['module'] === '432014TTLTBGTVTBCTTTNLSXLR') {
              dossierPart = '';
            } else if (vm.selectModule && vm.selectModule['module'] === '432014TTLTBGTVTBCTTTNLNK') {
              dossierPart = '';
            }
          } else {
            if (moduleSelected === 'COP') {
              dossierPart = '';
            } else if (moduleSelected === 'TT192012TTBGTVTDGLD') {
              dossierPart = '';
            } else if (moduleSelected === 'TT302011BGTVTCNCLKLXMCD') {
              dossierPart = '';
            } else if (moduleSelected === 'TT302011BGTVTTDTKXCG') {
              dossierPart = '';
            } else if (moduleSelected === 'TT302011BGTVTTDTKXMCD') {
              dossierPart = '';
            } else if (moduleSelected === 'TT302011BGTVTKTSPMXCG') {
              dossierPart = 'TP2';
            } else if (moduleSelected === 'TT302011BGTVTKTSPMXCNBB') {
              dossierPart = 'TP2';
            } else if (moduleSelected === 'TT302011BGTVTCNCLKLTXXCG') {
              dossierPart = 'TP4';
            } else if (moduleSelected === 'TT302011BGTVTCNCLKLTXXMTGM') {
              dossierPart = 'TP4';
            } else if (moduleSelected === 'TT302011BGTVTCNCLKLLKOTO') {
              dossierPart = 'TP2';
            } else if (moduleSelected === 'TT302011BGTVTCNCLKLLKXM') {
              dossierPart = 'TP2';
            } else if (moduleSelected === 'TT302011BGTVTCNCLKLTXXBBCN') {
              dossierPart = 'TP4';
            } else if (moduleSelected === 'TT302011BGTVTCNCLKLTXXBBCH') {
              dossierPart = 'TP4';
            } else if (moduleSelected === 'TT302011BGTVTCNCLKLTXXDD') {
              dossierPart = 'TP4';
            } else if ((moduleSelected === 'TT302011BGTVTKTSPMXBBCN' || moduleSelected === 'TT302011BGTVTKTSPMXCG')) {
              dossierPart = 'TP2';
            } else if (moduleSelected === 'TT302011BGTVTCPPXCG') {
              dossierPart = '';
            } else if (moduleSelected === '432014TTLTBGTVTBCTTTNLSXLR') {
              dossierPart = '';
            } else if (moduleSelected === '432014TTLTBGTVTBCTTTNLNK') {
              dossierPart = '';
            }
          }

          if (dossierPart != '' && result['total'] > 0) {
            vm.typeAnh = 1;
            result['data'].forEach(function (obj, index) {
              if (obj['dossierPartNo'] == dossierPart) { 
                obj['dossierId'] = dossierId; 
                obj['dossierIdGCN'] = dossierIdGCN; 
                vm.listAnh.push(obj); 
              }
            });
            if (vm.listAnh.length == 0) {
              alert("Không có ảnh sản phẩm!");
            } else {              
              vm.detailPage = 4;
            }
          } else if (dossierPart != '' && result['total'] == 0) {
            vm.typeAnh = 2;
            $.ajax({
              url: "/o/rest/v2/dossiers/history/get/path/" + certificaterecordno,
              type: "GET",
              headers: {
                groupId: window.themeDisplay.getScopeGroupId()
              },
              dataType: 'json',
              success: function(response) {
                if (response == {}) {
                  alert("Không có ảnh sản phẩm!");
                } else {
                  $.each(response, function(k, v){
                    vm.listAnh.push({
                      displayName: k
                    });
                  }); 
                  vm.detailPage = 4;
                }
              }
            });
          } else {
            vm.typeAnh = 3;
            alert("Không có ảnh sản phẩm!");
          }
        }
      });
    },
    viewBanVe: function (item, type) {
      var vm = this;
      vm.typeViewList = 2;
      var dossierId = item['dossierId'];
      $.ajax({
        url: "/o/rest/v2/dossiers/" + dossierId + "/files",
        type: "GET",
        headers: {
          groupId: window.themeDisplay.getScopeGroupId()
        },
        dataType: 'json',
        async: false,
        success: function(result) {
          var dossierPart = 'KQ3';
          vm.listAnh = [];
          if (result['total'] > 0) {
            vm.typeAnh = 1;
            result['data'].forEach(function (obj, index) {
              if (obj['dossierPartNo'] == dossierPart) { 
                obj['dossierId'] = dossierId; 
                vm.listAnh.push(obj); 
              }
            });
            if (vm.listAnh.length == 0) {
              alert("Không có bản vẽ nào!");
            } else {              
              vm.detailPage = 4;
            }
          } else {
            vm.typeAnh = 3;
            alert("Không có bản vẽ nào!");
          }
        }
      });
    },
    viewAnh: function(item, index) {
      var vm = this;
      var iFrame = document.getElementById("anhPdf");
      var notFound = document.getElementById("notFound");
      var url = "";

      if (vm.typeAnh == 1) {
        if (vm.certificateSelected == 1) {
          url = "/o/rest/v2/dossiers/" + item['dossierId'] + "/files/" + item['referenceUid'];
        } else {
          url = "/o/rest/v2/dossiers/" + item['dossierIdGCN'] + "/files/" + item['referenceUid'];
        }
      } else if (vm.typeAnh == 2){
        url = "/o/rest/v2/dossiers/history?path=/opt/dklr/data/image_history/" + item['displayName'];
      }

      var config_blob = {
        headers: {
          'groupId': themeDisplay.getScopeGroupId(),
        },
        responseType: 'blob'
      };

      axios.get(url, config_blob).then(function(response) {
        var url = window.URL.createObjectURL(response.data);
        iFrame.className = "";
        iFrame.innerHTML = '<iframe src="' + url + '" width="100%" height="100%"> </iframe>';
        notFound.innerHTML = '';
        setTimeout(function() {
          $("#anhPdf").find('iframe').contents().find('img').css({
            'width': '100%',
            'height': 'auto',
            'max-width': 'none',
            'max-height': '100vh',
            'object-fit': 'contain'
          })
        }, 500);
      }).catch(function(error) {
        console.log(error);
        notFound.innerHTML = 'Ảnh không tồn tại!';
      });     
    },
    undoDetailPageTSKT: function () {
      this.detailPage = 1;
    },
    addSearch() {
      const index = this.listSearch.length + 1;
      const item = {
        index,
        value: null,
        searchType: null,
        dataitem: null,
        dataCollection: [],
        conditionsSelect: {},
      };
      this.listSearch.push(item);
    },
    paggingData(config) {
      this.page = config["page"];
      let path = this.$router.history.current.path;
      let query = this.$router.history.current.query;
      this.$router.push({
        path: path,
        query: {
          ...query,
          page: config["page"],
        },
      });
    },
  },
  filters: {
    maXuong(value) {
      if (!value) {
        return;
      }
      return value.substring(value.length - 12, value.length);
    },
    money(value) {
      if (value) {
        var moneyCur = (value / 1).toFixed(0).replace(".", ",");
        return (
          moneyCur.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " VNĐ"
        );
      } else {
        return "";
      }
    },
  },
};
/* eslint-disable */
</script>



// WEBPACK FOOTER //
// Home_data_table.vue?30564350